<template>
  <div class="create-live-wrapper">
    <b-container fluid>


      <div class="action-BTN-mobile">
        <b-button            variant="light"
                             type="button" class="mr-2 Annuler" @click="goToListLive">{{
          $t('button.cancel')
          }}</b-button>
        <b-button
          :class="{'DifuserBtn':!show_start_date,'SaveBTN':show_start_date}"
          type="submit"
          @mousedown="submitForm"
          :disabled="$v.form.$error"
        > <i class="icon-dotv"></i> {{ $t('button.save') }}</b-button
        >
      </div>





      <!-- todo add tabs -->
      <div class="tabs-wrapper">
        <b-tabs content-class="mt-3" :noKeyNav="true">
          <b-tab
            v-for="(tab, index) in tabs"
            :key="index"
            :title="$t('form_live.tabs.' + tab + '.title')"
            :active="tab === activeTab"
            @click="changeTab(tab)"
          >


          </b-tab>
        </b-tabs>
        <div class="action-BTN">
          <b-button  type="button" variant="light" class="mr-2 Annuler" @click="goToListLive">{{
            $t('button.cancel')
            }}</b-button>
          <b-button
            :class="{'DifuserBtn':!show_start_date,'SaveBTN':show_start_date}"
            type="submit"
            @mousedown="submitForm"
            :disabled="$v.form.$error"
          > <i class="icon-dotv"></i> {{ $t('button.save') }}</b-button
          >
        </div>

      </div>
      <b-form
        @submit.prevent="handleSubmit"
        @reset="onReset"
        ref="form"
        class="needs-validation"
        :class="{ 'was-validated': $v.form.$anyDirty, 'not-ready': isEditMode && !ready }"
        novalidate
      >
        <!----
        <div class="text-right mb-2 d-lg-none">
          <b-button variant="light" type="button" class="mr-2" @click="goToListLive">{{
            $t('button.cancel')
          }}</b-button>
          <b-button
            variant="primary"
            type="submit"
            @mousedown="submitForm"
            :disabled="$v.form.$error"
            >{{ $t('button.save') }}</b-button
          >
        </div>-->
        <!--<div class="tabs-wrapper">-->
        <!--------- general part ----->
        <div class="general-tab" v-if="activeTab === 'general'">
          <b-row>
            <b-col  class="col-12 col-sm-12 col-xl-6">
              <div class="tabs-wrapper">
                <b-row>
                  <b-col md="12" sm="12">
                    <b-row>
                      <b-col md="6" sm="12">
                        <b-form-group
                          :description="$t('form_live.tabs.general.form.description_image')"
                          :label="$t('form_live.tabs.general.form.add_image')"
                          label-for="live-thumbnail"
                          label-class="primary"
                        >
                          <div class="vignette-infos">
                            <thumbnail-cropper
                              :crop-img="form.thumbnail"
                              @thumbnailUpdated="handleThumbnailUpdated"
                            ></thumbnail-cropper>
                            <span
                              class=" position-icon icon-infos "
                              v-b-tooltip.hover.right
                              :title="$t('form_live.tabs.general.form.infos.vignette')"
                            >
                            </span>
                          </div>
                        </b-form-group>
                      </b-col>
                    </b-row>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col>
                    <div class="form-group">
                      <label for="title" class="required primary">{{
                        $t('form_live.tabs.general.form.title')
                      }}</label>
                      <input
                        :placeholder="$t('form_live.tabs.general.form.title')"
                        type="text"
                        v-model="form.title"
                        id="title"
                        name="title"
                        class="form-control"
                        required
                      />
                      <div v-if="!$v.form.title.required" class="invalid-feedback">
                        {{ $t('form_live.tabs.required_message') }}
                      </div>
                    </div>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col>
                    <div class="form-group">
                      <label for="description" class="required primary">{{
                        $t('form_live.tabs.general.form.description')
                      }}</label>
                      <textarea
                        v-model="form.description"
                        class="form-control "
                        id="description"
                        :placeholder="$t('form_live.tabs.general.form.description')"
                        required
                        rows="3"
                      ></textarea>
                      <div v-if="!$v.form.description.required" class="invalid-feedback">
                        {{ $t('form_live.tabs.required_message') }}
                      </div>
                    </div>
                  </b-col>
                </b-row>
                <b-row v-has-permission="'lives_password_security_no_api'" has-permission="lives_password_security_no_api">
                  <b-col>
                    <div class="form-group">
                      <label for="title" class=" primary">{{
                        $t('form_live.tabs.general.form.access_live')
                      }}</label>
                      <b-form-radio-group v-model="form.secureAccess" name="type_access">
                        <b-row>
                          <b-col md="3" sm="12" style="min-width: 190px!important">
                            <b-form-radio :value="false"
                              >{{ $t('form_live.tabs.general.form.access_free') }}
                              <span
                                class=" position-icon icon-infos "
                                v-b-tooltip.hover.bottomleft
                                :title="$t('form_live.tabs.general.form.infos.access_free')"
                              >
                              </span>
                            </b-form-radio>

                          </b-col>
                          <b-col md="3" sm="12" style="min-width: 225px!important">
                            <b-form-radio :value="true">{{
                              $t('form_live.tabs.general.form.access_secure')
                            }}
                              <span
                                class=" position-icon icon-infos "
                                v-b-tooltip.hover.top
                                :title="$t('form_live.tabs.general.form.infos.access_secure')"
                              >
                            </span>
                            </b-form-radio>

                          </b-col>
                          <b-col md="6" sm="12"></b-col>
                        </b-row>
                      </b-form-radio-group>
                      <b-row>
                        <b-col md="3" sm="12"> </b-col>
                        <b-col md="9" sm="12">
                          <div class="form-group" v-if="form.secureAccess">
                            <div class="sub-form-control">
                              <!-- v-if="password"-->

                              <b-form-input
                                type="text"
                                v-model="form.pwd"
                                :placeholder="$t('form_live.tabs.general.form.placeholder_pass')"
                              ></b-form-input>
                            </div>
                            <div class="sub-form-control align-infos-live">
                              <b-form-checkbox
                                v-model="password"
                                class="primary generer-pwd"
                                @input="handleToggleSecured"
                                @change="handleToggleSecured"
                                >{{ $t('form_live.tabs.general.form.secure_pass') }}
                                <span
                                  class=" position-icon icon-infos "
                                  v-b-tooltip.hover.bottomleft
                                  :title="$t('form_live.tabs.general.form.infos.secure_pass')"
                                >
                              </span>
                              </b-form-checkbox>

                            </div>
                          </div>
                        </b-col>
                      </b-row>
                    </div>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col>
                    <div class="form-group align-infos-live">
                      <label class="primary ">{{
                        $t('form_live.tabs.general.form.schedule_live')
                      }}</label>
                      <b-form-checkbox switch size="lg" v-model="show_start_date" class="no-p-r"></b-form-checkbox>
                      <span class="position-icon icon-infos"></span>
                    </div>
                  </b-col>
                </b-row>
                <b-row v-if="show_start_date">
                  <b-col md="4" sm="12">
                    <div
                      class="form-group"
                      :class="{ 'is-invalid__custom': $v.form.startDate.$invalid }"
                    >
                      <label class="required primary">{{
                        $t('form_live.tabs.general.form.start_date')
                      }}</label>
                      <div id="filter-date" class="input_css input filter-date ">
                        <datepicker
                          id="start-date"
                          v-model="form.startDate"
                          input-class="form-control selectedDate"
                          wrapper-class="start-date-picker"
                          :bootstrap-styling="true"
                          :calendar-button="true"
                          :required="true"
                          :lang="$i18n.locale"
                          :disabled-days="disabledDate"
                          :format="'DD MMM YYYY'"
                          :active-color="getActiveColor"
                          :clearable="false"
                          :editable="false"
                        >
                          <template slot="calendar-icon">
                            <font-awesome-icon
                              class="calendar-icon "
                              :icon="{ prefix: 'fas', iconName: 'calendar-alt' }"
                            />
                          </template>
                        </datepicker>
                      </div>

                      <div v-if="!$v.form.startDate.required" class="invalid-feedback">
                        {{ $t('form_live.tabs.required_message') }}
                      </div>
                      <div v-else-if="!$v.form.startDate.minValue" class="invalid-feedback">
                        {{ $t('form_live.tabs.general.form.invalid_date') }}
                      </div>
                    </div>
                  </b-col>
                  <b-col md="4" sm="6">
                    <div
                      class="form-group"
                      :class="{ 'is-invalid__custom': $v.form.startTime.$invalid }"
                    >
                      <label for="start-time" class="required primary">{{
                        $t('form_live.tabs.general.form.start_hour')
                      }}</label>
                      <vue-clock-picker
                        id="start-time"
                        v-model="form.startTime"
                        input-class="form-control"
                        :active-color="getActiveColor"
                        :required="false"
                        :cancel-text="$t('button.cancel')"
                        :done-text="$t('button.done')"
                        :close-on-overlay="closeOnOverlay"
                      >
                      </vue-clock-picker>
                      <div v-if="!$v.form.startTime.required" class="invalid-feedback">
                        {{ $t('form_live.tabs.required_message') }}
                      </div>
                      <div v-else-if="!$v.form.startTime.minValue" class="invalid-feedback">
                        {{ $t('form_live.tabs.general.form.invalid_hour') }}
                      </div>
                    </div>
                  </b-col>
                  <b-col md="4" sm="6">
                    <div class="form-group ">
                      <label for="duration" >{{
                        $t('form_live.tabs.general.form.duration')
                      }}</label>
                      <div class="duration-live">

                        <vue-timepicker
                          v-model="form.duration"
                          format="HH:mm"
                          :placeholder="$t('form_live.tabs.general.form.duration')"
                          id="duration"
                          name="duration"
                        ></vue-timepicker>


                      </div>
                    </div>
                  </b-col>
                </b-row>
              </div>
            </b-col>

            <b-col class="col-12 col-sm-12 col-xl-6">
              <div class="tabs-wrapper">
                <b-row >
                  <b-col>
                    <div class="form-group ">
                      <div class="align-infos-live">
                        <label for="share_live" class="share-live primary"
                          >{{ $t('form_live.tabs.general.form.share_live.title') }}
                        </label>
                        <span
                          class=" position-icon icon-infos "
                          v-b-tooltip.hover.right
                          :title="$t('form_live.tabs.general.form.infos.share_live')"
                        >
                        </span>
                      </div>

                      <div class="share-live">
                        <input
                          type="text"
                          v-model="form.shareLive"
                          id="share_live"
                          name="share live"
                          class="form-control input-share"
                          readonly
                          disabled
                        />
                        <button
                          class="btn btn-secondary copy-button"
                          @click="copyButton($event, 'share_live')"
                          disabled
                        >
                          {{ $t('form_live.tabs.general.form.share_live.copy') }}
                        </button>
                      </div>
                    </div>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col>
                    <div class="form-group align-infos-live ">
                      <label class="primary  align-infos-live--size">{{
                        $t('form_live.tabs.general.form.archived_live')
                      }}</label>
                      <b-form-checkbox switch size="lg"   class="no-p-r" v-model="form.autoPub"></b-form-checkbox>
                      <span
                        class=" position-icon icon-infos "
                        v-b-tooltip.hover.bottomright
                        :title="$t('form_live.tabs.general.form.infos.archived_live')"
                      >
                      </span>
                    </div>
                  </b-col>
                </b-row>

                <b-row v-if="show_automatic_archiving">
                  <b-col v-has-permission="'lives_autopub_no_api'" has-permission="lives_autopub_no_api">
                    <div class="form-group">
                      <b-form-radio-group
                        v-model="form.autoPub"
                        name="type_video"
                        class="videos-visibility"
                        disabled
                      >
                        <b-form-radio  :value="false"
                          >{{ $t('form_live.tabs.general.form.video.invisible') }}
                          <span class="position-icon icon-infos"></span>
                        </b-form-radio>
                        <b-form-radio :value="true"
                          >{{ $t('form_live.tabs.general.form.video.visible') }}
                          <span class="position-icon icon-infos"></span>
                        </b-form-radio>
                      </b-form-radio-group>
                      <!-- todo add themes list select -->
                      <div class="form-group" v-if="form.autoPub">
                        <div class="align-infos-live">
                          <label class="primary"
                            >{{ $t('form_live.tabs.general.form.themes') }}
                          </label>
                          <span
                            class=" position-icon icon-infos "
                            v-b-tooltip.hover.right
                            :title="$t('form_live.tabs.general.form.infos.themes')"
                          >
                          </span>
                        </div>
                        <multiselect
                          v-model="form.themes"
                          :options="themesOptions"
                          :multiple="true"
                          track-by="id"
                          label="title"
                          :close-on-select="false"
                          placeholder=""
                          :select-label="$t('form_live.tabs.advanced.contributors.select_item')"
                          :deselect-label="$t('form_live.tabs.advanced.contributors.delete_item')"
                          :selected-label="$t('form_live.tabs.advanced.contributors.selected_item')"
                        >
                          <span slot="noResult">{{
                            $t('form_live.tabs.advanced.contributors.no_result')
                          }}</span>
                          <span slot="noOptions">{{
                            $t('form_live.tabs.advanced.contributors.no_options')
                          }}</span>
                          <template slot="singleLabel" slot-scope="{ option }">
                            <strong>{{ option.title }}</strong>
                          </template>

                          <template slot="option" slot-scope="{ option }">
                            <div :style="{ 'margin-left': option.index + 'em' }">
                              {{ option.title }}
                            </div>
                          </template>
                        </multiselect>
                      </div>
                    </div>
                  </b-col>
                </b-row>

                <b-row>
                  <b-col>
                    <div class="form-group">
                      <label class="primary">{{
                        $t('form_live.tabs.general.form.interactives_options.title')
                      }}</label>
                      <b-form-checkbox v-if="isEmpreinteClient" v-model="form.autoSip" class="primary">
                        {{ $t('form_live.tabs.frontOffice.options.interactive_tools.autoSip') }}
                      </b-form-checkbox>
                      <b-row>
                        <b-col md="4" sm="12" v-has-permission="'lives_fo_like_no_api'" has-permission="lives_fo_like_no_api">
                          <div class="form-group">
                            <b-form-checkbox v-model="form.foLike" class="primary">{{
                              $t('form_live.tabs.frontOffice.options.like')
                            }}</b-form-checkbox>
                          </div>
                        </b-col>
                        <b-col md="4" sm="12" v-has-permission="'lives_fo_chat_no_api'" has-permission="lives_fo_chat_no_api">
                          <div class="form-group">
                            <b-form-checkbox v-model="form.chat" class="primary">{{
                              $t('form_live.tabs.frontOffice.options.chat')
                            }}</b-form-checkbox>
                          </div>
                        </b-col>
                        <b-col md="4" sm="12" v-has-permission="'lives_fo_comment_no_api'" has-permission="lives_fo_comment_no_api">
                          <div class="form-group">
                            <b-form-checkbox v-model="form.foComment" class="primary">{{
                              $t('form_live.tabs.frontOffice.options.active_comment.title')
                            }}</b-form-checkbox>
                            <!--<div-->
                            <!--class="sub-form-control"-->
                            <!--v-show="form.foComment"-->
                            <!--v-has-permission="'lives_fo_comment_confirmation_no_api'"-->
                            <!--&gt;-->
                            <!--<b-form-checkbox v-model="form.isCommentValidation">{{-->
                            <!--$t('form_live.tabs.frontOffice.options.active_comment.confirm')-->
                            <!--}}</b-form-checkbox>-->
                            <!--</div>-->
                          </div>
                        </b-col>
                      </b-row>
                    </div>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col>
                    <div class="form-group">
                      <label class="primary ">{{
                        $t('form_live.tabs.general.form.multimedia_options')
                      }}</label>
                      <b-row v-has-permission="'lives_rich_media_no_api'" has-permission="lives_rich_media_no_api">
                        <b-col cols="12">
                          <div class="form-group align-infos-live">
                            <b-form-checkbox v-model="form.isRm"
                              >{{ $t('form_live.tabs.advanced.rich_media.title') }}
                            </b-form-checkbox>
                            <span
                              class=" position-icon icon-infos "
                              v-b-tooltip.hover.right
                              :title="$t('form_live.tabs.general.form.infos.rich_media')"
                            >
                            </span>
                          </div>
                        </b-col>
                        <b-col cols="12" v-if="form.isRm">
                          <div class="rm-tabs-wrapper">
                            <b-tabs content-class="mt-3" :noKeyNav="true">
                              <b-tab
                                v-if="hasPermission('lives_rich_media_chapter_no_api')"
                                active
                                @click="focusAddChapter"
                              >
                                <template slot="title">
                                  <div>
                                    <font-awesome-icon icon="list" />
                                  </div>
                                  <div class="d-none d-md-block ml-2">
                                    {{
                                      $t('form_live.tabs.advanced.rich_media.tabs.chapters.title')
                                    }}
                                  </div>
                                </template>
                                <!--<VuePerfectScrollbar-->
                                  <!--ref="ps-chapters"-->
                                  <!--class="scroll-area scroll-chapters"-->
                                <!--&gt;-->
                                  <b-row>
                                    <b-col md="12">
                                      <div class="chapters-wrapper">
                                        <draggable v-model="form.chapters" handle=".sort-handler">
                                          <div
                                            md="12"
                                            class="chapter-wrapper"
                                            v-for="(chapter, index) in form.chapters"
                                            :key="index"
                                          >
                                            <div class="chapter-container">
                                              <div class="sort-handler">
                                                <font-awesome-icon icon="bars" />
                                              </div>
                                              <div class="index">{{ index + 1 }}.&nbsp;</div>
                                              <div class="text" v-show="!chapter.isEditMode">
                                                {{ chapter.title }}
                                              </div>
                                              <b-form-group class="m-0"  v-show="chapter.isEditMode">
                                                <b-form-input
                                                  v-model="chapterTitle"
                                                  :placeholder="
                                                    $t(
                                                      'form_live.tabs.advanced.rich_media.tabs.chapters.fields.title',
                                                    )
                                                  "
                                                  @keyup.enter="toggleEditChapter(index)"
                                                ></b-form-input>
                                                <b-button
                                                  size="sm"
                                                  @click="toggleEditChapter(index)"
                                                  variant="light"
                                                  class="inline-submit-btn"
                                                  v-show="chapter.isEditMode && !!chapter.title"
                                                >
                                                  <font-awesome-icon
                                                    icon="check-circle"
                                                  ></font-awesome-icon>
                                                </b-button>
                                              </b-form-group>
                                            </div>
                                            <div
                                              class="rm-actions-wrapper"
                                              v-show="!chapter.isEditMode"
                                            >
                                              <b-button
                                                v-show="!isChapterEditMode"
                                                size="sm"
                                                @click.stop="toggleEditChapter(index, false)"
                                                variant="light"
                                              >
                                                <span class="icon-edit"></span>
                                              </b-button>
                                              <b-button
                                                size="sm"
                                                @click="removeChapter(index)"
                                                variant="light"
                                                class="btn-remove"
                                              >
                                                <span class="icon-trash"></span>
                                              </b-button>
                                            </div>
                                          </div>
                                        </draggable>
                                        <h5
                                          class="text-center m-3 c-grey-600"
                                          v-if="form.chapters.length === 0"
                                        >
                                          {{
                                            $t(
                                              'form_live.tabs.advanced.rich_media.tabs.chapters.empty',
                                            )
                                          }}
                                        </h5>
                                      </div>
                                    </b-col>
                                  </b-row>
                                <!--</VuePerfectScrollbar>-->
                                <div class="add-item-wrapper">
                                  <div class="position-relative">
                                    <b-form-input
                                      v-model="newChapter"
                                      :placeholder="
                                        $t(
                                          'form_live.tabs.advanced.rich_media.tabs.chapters.fields.new',
                                        )
                                      "
                                      @keyup.enter="addChapter"
                                      ref="newChapterInput"
                                    ></b-form-input>
                                    <b-button
                                      v-show="newChapter"
                                      size="sm"
                                      @click="addChapter"
                                      variant="light"
                                      class="inline-submit-btn"
                                    >
                                      <font-awesome-icon icon="plus-circle"></font-awesome-icon>
                                    </b-button>
                                  </div>
                                </div>
                              </b-tab>
                              <b-tab v-if="hasPermission('lives_rich_media_question_no_api')">
                                <template slot="title">
                                  <div>
                                    <span class="icon-question"></span>
                                  </div>
                                  <div class="d-none d-md-block ml-2">
                                    {{
                                      $t('form_live.tabs.advanced.rich_media.tabs.questions.title')
                                    }}
                                  </div>
                                </template>
                                <!--<VuePerfectScrollbar-->
                                  <!--ref="ps-questions"-->
                                  <!--class="scroll-area scroll-questions"-->
                                <!--&gt;-->
                                  <b-row>
                                    <b-col md="12">
                                      <div class="chapters-wrapper">
                                        <draggable v-model="form.questions" handle=".sort-handler">
                                          <div
                                            md="12"
                                            class="chapter-wrapper"
                                            v-for="(question, index) in form.questions"
                                            :key="index"
                                          >
                                            <div
                                              class="chapter-container question"
                                              :class="{ 'is-open': question.isEditMode }"
                                            >
                                              <div class="sort-handler">
                                                <font-awesome-icon icon="bars" />
                                              </div>
                                              <div class="index">{{ index + 1 }}.&nbsp;</div>
                                              <div class="text" v-show="!question.isEditMode">
                                                {{ question.question }}
                                              </div>
                                              <question-form
                                                v-if="question.isEditMode"
                                                :question="question"
                                                :buttonLabel="
                                                  $t(
                                                    'form_live.tabs.advanced.rich_media.tabs.questions.edit',
                                                  )
                                                "
                                                @addQuestion="updateQuestion($event, index)"
                                                @closeForm="toggleEditQuestion(index)"
                                              >
                                              </question-form>
                                            </div>
                                            <div
                                              class="rm-actions-wrapper"
                                              v-show="!question.isEditMode"
                                            >
                                              <b-button
                                                v-show="!isQuestionEditMode"
                                                size="sm"
                                                @click.stop="toggleEditQuestion(index)"
                                                variant="light"
                                              >
                                                <span class="icon-edit"></span>
                                              </b-button>
                                              <b-button
                                                size="sm"
                                                @click="removeQuestion(index)"
                                                variant="light"
                                                class="btn-remove"
                                              >
                                                <span class="icon-trash"></span>
                                              </b-button>
                                            </div>
                                          </div>
                                        </draggable>
                                        <h5
                                          class="text-center m-3 c-grey-600"
                                          v-if="form.questions.length === 0"
                                        >
                                          {{
                                            $t(
                                              'form_live.tabs.advanced.rich_media.tabs.questions.empty',
                                            )
                                          }}
                                        </h5>
                                      </div>
                                    </b-col>
                                  </b-row>
                                <!--</VuePerfectScrollbar>-->
                                <div class="add-item-wrapper">
                                  <question-form
                                    v-if="addQuestionMode"
                                    @addQuestion="addQuestion"
                                    @closeForm="addQuestionMode = false"
                                  >
                                    <label slot="title">{{
                                      $t('form_live.tabs.advanced.rich_media.tabs.questions.new')
                                    }}</label>
                                  </question-form>
                                  <b-row v-if="!addQuestionMode">
                                    <b-col>
                                      <div class="float-right">
                                        <b-button
                                          variant="link"
                                          type="button"
                                          @click="setAddQuestionMode(true)"
                                        >
                                          <font-awesome-icon icon="plus-circle" />
                                          {{
                                            $t(
                                              'form_live.tabs.advanced.rich_media.tabs.questions.add_new',
                                            )
                                          }}</b-button
                                        >
                                      </div>
                                    </b-col>
                                  </b-row>
                                </div>
                              </b-tab>
                              <b-tab
                                @click="updateScrollbar"
                                v-has-permission="'lives_rich_media_slides_no_api'"
                                has-permission="lives_rich_media_slides_no_api"
                              >
                                <template slot="title">
                                  <div>
                                    <font-awesome-icon icon="th-large" />
                                  </div>
                                  <div class="d-none d-md-block ml-2">
                                    {{ $t('form_live.tabs.advanced.rich_media.tabs.slides.title') }}
                                  </div>
                                </template>

                                <div class="slides-wrapper">
                                  <!--<VuePerfectScrollbar ref="ps-slides" class="scroll-area">-->
                                    <draggable v-model="form.slides" class="row">
                                      <b-col
                                        lg="2"
                                        md="3"
                                        sm="4"
                                        class="slide-wrapper"
                                        v-for="(slide, index) in form.slides"
                                        :key="index"
                                      >
                                        <figure class="img-fluid">
                                          <div class="type-tag">
                                            <span
                                              :class="
                                                'icon-' +
                                                  (slide.slideType === 'Image'
                                                    ? 'picture'
                                                    : 'video')
                                              "
                                            ></span>
                                          </div>
                                          <img
                                            v-if="slide.slideType === 'Image'"
                                            :src="slide.urlSlide"
                                            alt=""
                                          />
                                          <video
                                            v-if="slide.slideType === 'Video'"
                                            :src="slide.urlSlide"
                                            alt=""
                                          ></video>
                                          <div class="more-btn-container">
                                            <b-dropdown
                                              variant="link"
                                              toggle-class="text-decoration-none"
                                              no-caret
                                            >
                                              <template slot="button-content">
                                                <span class="icon-more"></span>
                                              </template>
                                              <b-dropdown-item @click.stop="replaceSlide(index)">
                                                <span class="icon-edit"></span>
                                                {{
                                                  $t(
                                                    'form_live.tabs.advanced.rich_media.tabs.slides.edit',
                                                  )
                                                }}
                                              </b-dropdown-item>
                                              <b-dropdown-item @click.stop="removeSlide(index)">
                                                <span class="icon-trash"></span>
                                                {{
                                                  $t(
                                                    'form_live.tabs.advanced.rich_media.tabs.slides.delete',
                                                  )
                                                }}
                                              </b-dropdown-item>
                                            </b-dropdown>
                                          </div>
                                        </figure>
                                      </b-col>
                                    </draggable>
                                  <!--</VuePerfectScrollbar>-->
                                </div>
                                <div class="dz-upload-wrapper">
                                  <vue-dropzone
                                    id="slides-dz"
                                    ref="slidesDZ"
                                    :options="getDropzoneOptions('media')"
                                    :auto-process-queue="false"
                                    @vdropzone-files-added="handleDzSlideAdded"
                                    @vdropzone-file-added-manually="handleDzSlideAdded"
                                    @vdropzone-complete="handleDzSlideCompleted"
                                  >
                                  </vue-dropzone>
                                </div>
                              </b-tab>
                            </b-tabs>
                          </div>
                        </b-col>
                      </b-row>
                      <b-row v-has-permission="'lives_associate_files_no_api'" has-permission="lives_associate_files_no_api">
                        <b-col cols="12">
                          <div class="form-group align-infos-live">
                            <b-form-checkbox v-model="joinFile"
                              >{{ $t('form_live.tabs.advanced.attaching_files') }}
                            </b-form-checkbox>
                            <span
                              class=" position-icon icon-infos "
                              v-b-tooltip.hover.right
                              :title="$t('form_live.tabs.general.form.infos.attaching_files')"
                            >
                            </span>
                          </div>
                          <div class="attached-files-wrapper" v-if="joinFile">
                            <div class="attached-file" v-for="(file, index) in form.files">
                              <b-button
                                variant="link"
                                class="attached-file__btn-remove"
                                @click="removeFile(index)"
                              >
                                <font-awesome-icon icon="times-circle"></font-awesome-icon>
                              </b-button>
                              <div class="attached-file__icon">
                                <font-awesome-icon :icon="file.icon" />
                              </div>
                              <div class="attached-file__name">
                                {{ file.fileName }}
                              </div>
                            </div>
                          </div>
                          <vue-dropzone
                            id="files-dz"
                            ref="filesDZ"
                            v-if="joinFile"
                            :options="getDropzoneOptions('file')"
                            :auto-process-queue="false"
                            @vdropzone-files-added="handleDzFileAdded"
                            @vdropzone-file-added-manually="handleDzFileAdded"
                            @vdropzone-complete="handleDzFileCompleted"
                          ></vue-dropzone>
                        </b-col>
                      </b-row>
                    </div>
                  </b-col>
                </b-row>
                <b-row v-has-permission="'lives_associate_users_no_api'" has-permission="lives_associate_users_no_api">
                  <b-col>
                    <div class="form-group">
                      <label class="primary"
                        >{{ $t('form_live.tabs.general.form.publish') }}
                      </label>
                      <multiselect
                        v-model="form.contributors"
                        :options="contributorsOptions"
                        :multiple="true"
                        track-by="id"
                        label="name"
                        placeholder=""
                        :close-on-select="false"
                        :select-label="$t('form_live.tabs.advanced.contributors.select_item')"
                        :deselect-label="$t('form_live.tabs.advanced.contributors.delete_item')"
                        :selected-label="$t('form_live.tabs.advanced.contributors.selected_item')"
                      >
                        <span slot="noResult">{{
                          $t('form_live.tabs.advanced.contributors.no_result')
                        }}</span>
                        <span slot="noOptions">{{
                          $t('form_live.tabs.advanced.contributors.no_options')
                        }}</span>
                        <template slot="singleLabel" slot-scope="{ option }">
                          <strong>{{ option.name }}</strong>
                        </template>
                      </multiselect>
                    </div>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col>
                    <div class="form-group ">
                      <div class="align-infos-live">
                        <label class="primary">{{ $t('form_live.tabs.general.form.tags') }} </label>
                        <span
                          class=" position-icon icon-infos "
                          v-b-tooltip.hover.right
                          :title="$t('form_live.tabs.general.form.infos.tags')"
                        >
                        </span>
                      </div>

                      <input-tag v-model="form.tags"></input-tag>
                    </div>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col>
                    <div class="form-group">
                      <label class="primary conf-label" disabled
                        >{{ $t('form_live.tabs.general.form.interactives_options.title') }}
                        <span class="position-icon icon-infos"></span>
                      </label>
                      <b-col>
                        <div class="form-group interactive-options">
                          <b-form-checkbox disabled class="primary"
                            >{{
                              $t('form_live.tabs.general.form.interactives_options.social_media.fb')
                            }}
                            <span class="tm">TM</span></b-form-checkbox
                          >
                        </div>
                      </b-col>
                      <b-col>
                        <div class="form-group interactive-options">
                          <b-form-checkbox disabled class="primary"
                            >{{
                              $t(
                                'form_live.tabs.general.form.interactives_options.social_media.youtube',
                              )
                            }}
                            <span class="tm">TM</span></b-form-checkbox
                          >
                        </div>
                      </b-col>
                    </div>
                  </b-col>
                </b-row>
              </div>
            </b-col>
          </b-row>
        </div>

        <!--------- advanced params part ----->
        <div class="advanced-tab" v-if="activeTab === 'advanced'">
          <div class="form-group" v-has-permission="'lives_type_no_api'" has-permission="lives_type_no_api">
            <label class="primary">{{ $t('form_live.tabs.advanced.type.title') }}</label>
            <b-form-radio-group v-model="form.isCdn" name="type">
              <b-form-radio :value="false">{{
                $t('form_live.tabs.advanced.type.intranet')
              }}</b-form-radio>
              <b-form-radio :value="true">{{
                $t('form_live.tabs.advanced.type.internet')
              }}</b-form-radio>
            </b-form-radio-group>
          </div>
          <div
            class="form-group"
            v-has-permission="getDifferentDiffusionPermission"
          >
            <label class="primary">{{ $t('form_live.tabs.advanced.diffusion.title') }}</label>
            <b-form-radio-group v-model="form.diffusion" @input="handleDiffusionTypeChanged()">
              <b-row>
                <b-col md="3" sm="6" v-has-permission="'lives_webinar_no_api'" has-permission="lives_webinar_no_api">
                  <b-form-radio value="webinar">{{
                    $t('form_live.tabs.advanced.diffusion.webinar')
                  }}</b-form-radio>
                </b-col>
                <b-col md="3" sm="6">
                  <b-form-radio value="isPearl" v-has-permission="'lives_encoder_no_api'" has-permission="lives_encoder_no_api">{{
                    $t('form_live.tabs.advanced.diffusion.encoding')
                  }}</b-form-radio>
                </b-col>
                <b-col md="6" sm="12">
                  <b-form-radio
                    value="screenShare"
                    v-has-permission="'lives_screen_share_no_api'"
                    has-permission="lives_screen_share_no_api"
                    >{{ $t('form_live.tabs.advanced.diffusion.sharing') }}</b-form-radio
                  >
                  <div v-if="form.screenShare">
                    <b-form-select
                      class="screen-share-select"
                      v-model="form.screenType"
                      :options="screenTypeOptions"
                    ></b-form-select>
                  </div>
                </b-col>
              </b-row>
            </b-form-radio-group>
          </div>
          <div class="form-group">
            <label
              class="primary"
              v-has-permission="'lives_private_no_api,lives_active_no_api,lives_autopub_no_api'"
              has-permission="lives_private_no_api,lives_active_no_api,lives_autopub_no_api"
              >{{ $t('form_live.tabs.advanced.options.title') }}</label
            >
            <b-row>
              <b-col md="3" sm="12" v-has-permission="'lives_private_no_api'" has-permission="lives_private_no_api">
                <div class="form-group">
                  <b-form-checkbox v-model="form.private">{{
                    $t('form_live.tabs.advanced.options.private_video')
                  }}</b-form-checkbox>
                </div>
              </b-col>
              <b-col md="3" sm="12" v-has-permission="'lives_active_no_api'" has-permission="lives_active_no_api">
                <div class="form-group">
                  <b-form-checkbox v-model="form.active">{{
                    $t('form_live.tabs.advanced.options.active_video')
                  }}</b-form-checkbox>
                </div>
              </b-col>
              <b-col md="3" sm="12" v-has-permission="'lives_autopub_no_api'" has-permission="lives_autopub_no_api">
                <div class="form-group">
                  <b-form-checkbox v-model="form.autoPub">{{
                    $t('form_live.tabs.advanced.options.automatic_share')
                  }}</b-form-checkbox>
                </div>
              </b-col>
            </b-row>
            <b-row v-has-permission="'lives_associate_users_no_api'" has-permission="lives_associate_users_no_api">
              <b-col cols="12">
                <div class="form-group">
                  <label>{{ $t('form_live.tabs.advanced.contributors.title') }}</label>
                  <multiselect
                    v-model="form.contributors"
                    :options="contributorsOptions"
                    :multiple="true"
                    track-by="id"
                    label="name"
                    placeholder=""
                    :close-on-select="false"
                    :select-label="$t('form_live.tabs.advanced.contributors.select_item')"
                    :deselect-label="$t('form_live.tabs.advanced.contributors.delete_item')"
                    :selected-label="$t('form_live.tabs.advanced.contributors.selected_item')"
                  >
                    <span slot="noResult">{{
                      $t('form_live.tabs.advanced.contributors.no_result')
                    }}</span>
                    <span slot="noOptions">{{
                      $t('form_live.tabs.advanced.contributors.no_options')
                    }}</span>
                    <template slot="singleLabel" slot-scope="{ option }">
                      <strong>{{ option.name }}</strong>
                    </template>
                  </multiselect>
                </div>
              </b-col>
            </b-row>
            <b-row v-has-permission="'lives_rich_media_no_api'" has-permission="lives_rich_media_no_api">
              <b-col cols="12">
                <div class="form-group">
                  <b-form-checkbox v-model="form.isRm">{{
                    $t('form_live.tabs.advanced.rich_media.title')
                  }}</b-form-checkbox>
                </div>
              </b-col>

              <b-col cols="12" v-if="form.isRm">
                <div class="rm-tabs-wrapper">
                  <b-tabs content-class="mt-3" :noKeyNav="true">
                    <b-tab
                      v-if="hasPermission('lives_rich_media_chapter_no_api')"
                      active
                      @click="focusAddChapter"
                    >
                      <template slot="title">
                        <div>
                          <font-awesome-icon icon="list" />
                        </div>
                        <div class="d-none d-md-block ml-2">
                          {{ $t('form_live.tabs.advanced.rich_media.tabs.chapters.title') }}
                        </div>
                      </template>
                      <VuePerfectScrollbar ref="ps-chapters" class="scroll-area scroll-chapters">
                        <b-row>
                          <b-col md="12">
                            <div class="chapters-wrapper">
                              <draggable v-model="form.chapters" handle=".sort-handler">
                                <div
                                  md="12"
                                  class="chapter-wrapper"
                                  v-for="(chapter, index) in form.chapters"
                                  :key="index"
                                >
                                  <div class="chapter-container">
                                    <div class="sort-handler">
                                      <font-awesome-icon icon="bars" />
                                    </div>
                                    <div class="index">{{ index + 1 }}.&nbsp;</div>
                                    <div  class="text" v-show="!chapter.isEditMode">
                                      {{ chapter.title }}
                                    </div>
                                    <b-form-group class="m-0"  v-show="chapter.isEditMode" >
                                      <b-form-input
                                        v-model="chapterTitle"
                                        :placeholder="
                                          $t(
                                            'form_live.tabs.advanced.rich_media.tabs.chapters.fields.title',
                                          )
                                        "
                                        @keyup.enter="toggleEditChapter(index)"
                                      ></b-form-input>
                                      <b-button
                                        size="sm"
                                        @click="toggleEditChapter(index)"
                                        variant="light"
                                        class="inline-submit-btn"
                                        v-show="chapter.isEditMode && !!chapter.title"
                                      >
                                        <font-awesome-icon icon="check-circle"></font-awesome-icon>
                                      </b-button>
                                    </b-form-group>
                                  </div>
                                  <div class="rm-actions-wrapper" v-show="!chapter.isEditMode">
                                    <b-button
                                      v-show="!isChapterEditMode"
                                      size="sm"
                                      @click.stop="toggleEditChapter(index, false)"
                                      variant="light"
                                    >
                                      <span class="icon-edit"></span>
                                    </b-button>
                                    <b-button
                                      size="sm"
                                      @click="removeChapter(index)"
                                      variant="light"
                                      class="btn-remove"
                                    >
                                      <span class="icon-trash"></span>
                                    </b-button>
                                  </div>
                                </div>
                              </draggable>
                              <h5
                                class="text-center m-3 c-grey-600"
                                v-if="form.chapters.length === 0"
                              >
                                {{ $t('form_live.tabs.advanced.rich_media.tabs.chapters.empty') }}
                              </h5>
                            </div>
                          </b-col>
                        </b-row>
                      </VuePerfectScrollbar>
                      <div class="add-item-wrapper">
                        <div class="position-relative">
                          <b-form-input
                            v-model="newChapter"
                            :placeholder="
                              $t('form_live.tabs.advanced.rich_media.tabs.chapters.fields.new')
                            "
                            @keyup.enter="addChapter"
                            ref="newChapterInput"
                          ></b-form-input>
                          <b-button
                            v-show="newChapter"
                            size="sm"
                            @click="addChapter"
                            variant="light"
                            class="inline-submit-btn"
                          >
                            <font-awesome-icon icon="plus-circle"></font-awesome-icon>
                          </b-button>
                        </div>
                      </div>
                    </b-tab>
                    <b-tab v-if="hasPermission('lives_rich_media_question_no_api')">
                      <template slot="title">
                        <div>
                          <span class="icon-question"></span>
                        </div>
                        <div class="d-none d-md-block ml-2">
                          {{ $t('form_live.tabs.advanced.rich_media.tabs.questions.title') }}
                        </div>
                      </template>
                      <VuePerfectScrollbar ref="ps-questions" class="scroll-area scroll-questions">
                        <b-row>
                          <b-col md="12">
                            <div class="chapters-wrapper">
                              <draggable v-model="form.questions" handle=".sort-handler">
                                <div
                                  md="12"
                                  class="chapter-wrapper"
                                  v-for="(question, index) in form.questions"
                                  :key="index"
                                >
                                  <div
                                    class="chapter-container question"
                                    :class="{ 'is-open': question.isEditMode }"
                                  >
                                    <div class="sort-handler">
                                      <font-awesome-icon icon="bars" />
                                    </div>
                                    <div class="index">{{ index + 1 }}.&nbsp;</div>
                                    <div class="text" v-show="!question.isEditMode">
                                      {{ question.question }}
                                    </div>
                                    <question-form
                                      v-if="question.isEditMode"
                                      :question="question"
                                      :buttonLabel="
                                        $t('form_live.tabs.advanced.rich_media.tabs.questions.edit')
                                      "
                                      @addQuestion="updateQuestion($event, index)"
                                      @closeForm="toggleEditQuestion(index)"
                                    >
                                    </question-form>
                                  </div>
                                  <div class="rm-actions-wrapper" v-show="!question.isEditMode">
                                    <b-button
                                      v-show="!isQuestionEditMode"
                                      size="sm"
                                      @click.stop="toggleEditQuestion(index)"
                                      variant="light"
                                    >
                                      <span class="icon-edit"></span>
                                    </b-button>
                                    <b-button
                                      size="sm"
                                      @click="removeQuestion(index)"
                                      variant="light"
                                      class="btn-remove"
                                    >
                                      <span class="icon-trash"></span>
                                    </b-button>
                                  </div>
                                </div>
                              </draggable>
                              <h5
                                class="text-center m-3 c-grey-600"
                                v-if="form.questions.length === 0"
                              >
                                {{ $t('form_live.tabs.advanced.rich_media.tabs.questions.empty') }}
                              </h5>
                            </div>
                          </b-col>
                        </b-row>
                      </VuePerfectScrollbar>
                      <div class="add-item-wrapper">
                        <question-form
                          v-if="addQuestionMode"
                          @addQuestion="addQuestion"
                          @closeForm="addQuestionMode = false"
                        >
                          <label slot="title">{{
                            $t('form_live.tabs.advanced.rich_media.tabs.questions.new')
                          }}</label>
                        </question-form>
                        <b-row v-if="!addQuestionMode">
                          <b-col>
                            <div class="float-right">
                              <b-button
                                variant="link"
                                type="button"
                                @click="setAddQuestionMode(true)"
                              >
                                <font-awesome-icon icon="plus-circle" />
                                {{
                                  $t('form_live.tabs.advanced.rich_media.tabs.questions.add_new')
                                }}</b-button
                              >
                            </div>
                          </b-col>
                        </b-row>
                      </div>
                    </b-tab>
                    <b-tab
                      @click="updateScrollbar"
                      v-has-permission="'lives_rich_media_slides_no_api'"
                      has-permission="lives_rich_media_slides_no_api"
                    >
                      <template slot="title">
                        <div>
                          <font-awesome-icon icon="th-large" />
                        </div>
                        <div class="d-none d-md-block ml-2">
                          {{ $t('form_live.tabs.advanced.rich_media.tabs.slides.title') }}
                        </div>
                      </template>

                      <div class="slides-wrapper">
                        <VuePerfectScrollbar ref="ps-slides" class="scroll-area">
                          <draggable v-model="form.slides" class="row">
                            <b-col
                              lg="2"
                              md="3"
                              sm="4"
                              class="slide-wrapper"
                              v-for="(slide, index) in form.slides"
                              :key="index"
                            >
                              <figure class="img-fluid">
                                <div class="type-tag">
                                  <span
                                    :class="
                                      'icon-' + (slide.slideType === 'Image' ? 'picture' : 'video')
                                    "
                                  ></span>
                                </div>
                                <img
                                  v-if="slide.slideType === 'Image'"
                                  :src="slide.urlSlide"
                                  alt=""
                                />
                                <video
                                  v-if="slide.slideType === 'Video'"
                                  :src="slide.urlSlide"
                                  alt=""
                                ></video>
                                <div class="more-btn-container">
                                  <b-dropdown
                                    variant="link"
                                    toggle-class="text-decoration-none"
                                    no-caret
                                  >
                                    <template slot="button-content">
                                      <span class="icon-more"></span>
                                    </template>
                                    <b-dropdown-item @click.stop="replaceSlide(index)">
                                      <span class="icon-edit"></span>
                                      {{
                                        $t('form_live.tabs.advanced.rich_media.tabs.slides.edit')
                                      }}
                                    </b-dropdown-item>
                                    <b-dropdown-item @click.stop="removeSlide(index)">
                                      <span class="icon-trash"></span>
                                      {{
                                        $t('form_live.tabs.advanced.rich_media.tabs.slides.delete')
                                      }}
                                    </b-dropdown-item>
                                  </b-dropdown>
                                </div>
                              </figure>
                            </b-col>
                          </draggable>
                        </VuePerfectScrollbar>
                      </div>
                      <!--<div class="dz-upload-wrapper">-->
                      <!--<vue-dropzone-->
                      <!--id="slides-dz"-->
                      <!--ref="slidesDZ"-->
                      <!--:options="getDropzoneOptions('media')"-->
                      <!--:auto-process-queue="false"-->
                      <!--@vdropzone-files-added="handleDzSlideAdded"-->
                      <!--@vdropzone-file-added-manually="handleDzSlideAdded"-->
                      <!--@vdropzone-complete="handleDzSlideCompleted"-->
                      <!--&gt;-->
                      <!--</vue-dropzone>-->
                      <!--</div>-->
                    </b-tab>
                  </b-tabs>
                </div>
              </b-col>
            </b-row>
            <b-row v-has-permission="'lives_associate_files_no_api'" has-permission="lives_associate_files_no_api">
              <b-col cols="12">
                <div class="form-group">
                  <b-form-checkbox v-model="form.foFilesShare" class="primary">{{
                    $t('form_live.tabs.frontOffice.options.sharing_files')
                  }}</b-form-checkbox>
                  <b-form-checkbox v-model="joinFile">{{
                    $t('form_live.tabs.advanced.attaching_files')
                  }}</b-form-checkbox>
                </div>
                <div class="attached-files-wrapper" v-if="joinFile">
                  <div class="attached-file" v-for="(file, index) in form.files">
                    <b-button
                      variant="link"
                      class="attached-file__btn-remove"
                      @click="removeFile(index)"
                    >
                      <font-awesome-icon icon="times-circle"></font-awesome-icon>
                    </b-button>
                    <div class="attached-file__icon">
                      <font-awesome-icon :icon="file.icon" />
                    </div>
                    <div class="attached-file__name">
                      {{ file.fileName }}
                    </div>
                  </div>
                </div>
                <!--<vue-dropzone-->
                <!--id="files-dz"-->
                <!--ref="filesDZ"-->
                <!--v-if="joinFile"-->
                <!--:options="getDropzoneOptions('file')"-->
                <!--:auto-process-queue="false"-->
                <!--@vdropzone-files-added="handleDzFileAdded"-->
                <!--@vdropzone-file-added-manually="handleDzFileAdded"-->
                <!--@vdropzone-complete="handleDzFileCompleted"-->
                <!--&gt;</vue-dropzone>-->
                <div class="documents-share-panel mt-3" v-if="form.foFilesShare">
                  <div class="documents-share-panel__header">
                    <div>
                      <label class="primary mb-0">{{
                        $t('form_live.tabs.advanced.documents.title')
                      }}</label>
                    </div>
                    <div class="documents-share-panel__actions">
                      <b-button
                        variant="light"
                        size="sm"
                        type="button"
                        @click="fetchLiveDocuments"
                        :disabled="!$route.params.id || documentsLoading"
                      >
                        {{ $t('form_live.tabs.advanced.documents.refresh') }}
                      </b-button>
                      <b-button
                        variant="primary"
                        size="sm"
                        type="button"
                        @click="triggerLiveDocumentUpload"
                        :disabled="documentsUploading"
                      >
                        {{ $t('form_live.tabs.advanced.documents.upload') }}
                      </b-button>
                    </div>
                  </div>

                  <p
                    class="documents-share-panel__hint"
                    v-if="!$route.params.id"
                  >
                    {{ $t('form_live.tabs.advanced.documents.save_first') }}
                  </p>

                  <b-form-checkbox
                    v-model="form.doc_public"
                    class="mt-2"
                  >
                    {{ $t('form_live.tabs.advanced.documents.publish_default') }}
                  </b-form-checkbox>

                  <div v-if="documentsLoading" class="documents-share-panel__state">
                    {{ $t('form_live.tabs.advanced.documents.refresh') }}...
                  </div>

                  <div v-else-if="managedLiveDocuments.length === 0" class="documents-share-panel__state">
                    {{ $t('form_live.tabs.advanced.documents.empty') }}
                  </div>

                  <div v-else class="documents-share-list">
                    <div
                      v-for="document in managedLiveDocuments"
                      :key="document.localId || document.id"
                      class="documents-share-item"
                    >
                      <div class="documents-share-item__main">
                        <div class="documents-share-item__name">
                          {{ getManagedDocumentName(document) }}
                        </div>
                        <div class="documents-share-item__meta">
                          <span
                            class="documents-share-item__badge"
                            :class="{
                              'is-public': isManagedDocumentPublic(document),
                              'is-pending': document.isPending,
                            }"
                          >
                            {{
                              document.isPending
                                ? $t('form_live.tabs.advanced.documents.pending')
                                : isManagedDocumentPublic(document)
                                  ? $t('form_live.tabs.advanced.documents.public')
                                  : $t('form_live.tabs.advanced.documents.private')
                            }}
                          </span>
                        </div>
                      </div>
                      <div class="documents-share-item__controls">
                        <b-button
                          variant="outline-warning"
                          size="sm"
                          type="button"
                          @click="toggleLiveDocumentPublish(document, !isManagedDocumentPublic(document))"
                          :disabled="document.isPending"
                        >
                          <font-awesome-icon icon="share-alt" />
                        </b-button>
                        <b-button
                          variant="outline-danger"
                          size="sm"
                          type="button"
                          @click="deleteLiveDocument(document)"
                          :disabled="documentsDeletingId === (document.id || document.localId)"
                        >
                          <font-awesome-icon icon="trash" />
                        </b-button>
                      </div>
                    </div>
                  </div>
                </div>
                <input
                  ref="liveDocumentsInput"
                  type="file"
                  multiple
                  class="d-none"
                  @change="handleLiveDocumentFileChange"
                />
              </b-col>
            </b-row>
          </div>
        </div>
        <!--------- configuration params  part ----->
        <div class="configuration-tab" v-if="activeTab === 'configuration'">
          <b-row>
            <b-col class="col-12 col-sm-12 col-xl-6">
              <div class="tabs-wrapper">
                <b-row v-if="templates.length > 0">
                  <b-col>
                    <div class="form-group">
                      <label for="title" class=" primary"
                        >{{ $t('form_live.tabs.configuration.form.skins_live') }}
                        <span
                          class=" position-icon icon-infos "
                          v-b-tooltip.hover.right
                          :title="$t('form_live.tabs.configuration.form.infos.skins_live')"
                        >
                        </span>
                      </label>
                      <div class=" container-default__themes__container__cards">
                        <div class="row">
                          <div
                            class=" col-lg-3 template"
                            v-for="(theme, index) in templates"
                            :key="index"
                          >
                            <b-card
                              :title="$t('skin.template.title')"
                              :img-src="theme.image"
                              img-alt="Image"
                              img-top
                              tag="article"
                              class="mb-2 template-card"
                              :id="['template-card-' + index]"
                              @click="selectTheme(theme)"
                              :class="{
                                selected: isSelectedTheme && form.idTemplate === theme.id,
                              }"
                            >
                            </b-card>
                            <p
                              class="template-title"
                              :class="{
                                selected: isSelectedTheme && form.idTemplate === theme.id,
                              }"
                            >
                              {{ theme.label }}
                            </p>
                          </div>
                          <div class=" col-lg-3 template" v-if="templates.length > 2">
                            <b-card
                              :title="$t('skin.template.title')"
                              img-alt="Image"
                              img-top
                              tag="article"
                              class="mb-2 show-more"
                              :id="['template-card']"
                              @click="showMore"
                              overlay
                            >
                              <b-card-text class="show-more-templates">
                                <p
                                  class="nb-rest-templates position-text"
                                  v-if="!showMoreTemplates"
                                >
                                  {{ '(' + nb_rest + ')' }} {{ 'templates' }}
                                </p>
                                <p class="title-show-more position-text">
                                  {{ $t('form_live.tabs.configuration.form.' + showText) }}
                                </p>
                              </b-card-text>
                            </b-card>
                          </div>
                        </div>
                      </div>
                    </div>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col>
                    <div class="custom-configuration " v-has-permission="'lives_conf_post_add'" has-permission="lives_conf_post_add">
                      <!---- radio button message--->
                      <div class="form-group">
                        <label for="title" class=" secondary ">{{
                          $t('form_live.tabs.configuration.form.infos_live')
                        }}</label>
                        <b-form-radio
                          v-model="form.conf.type"
                          disabled
                          value="Message"
                          v-has-permission="'lives_conf_message_option'" has-permission="lives_conf_message_option"
                          >{{ $t('form_live.tabs.configuration.form.message.title') }}
                          <span
                            class=" position-icon icon-infos "
                            v-b-tooltip.hover.right
                            :title="$t('form_live.tabs.configuration.form.infos.message')"
                          >
                          </span>
                        </b-form-radio>
                        <textarea
                          rows="5" maxlength="255"
                          v-show="form.conf.type === 'Message'"
                          v-model="form.conf.message"
                          class="form-control "
                          :placeholder="$t('form_live.tabs.configuration.form.message.description')"
                          required
                          @keyup="removeError($event)"
                          @focus="removeError($event)"
                        ></textarea>
                        <div v-if="this.showErrorMessage" class="error_message">
                          {{ $t('form_live.tabs.error_long_message') }}
                        </div>
                        <div v-if="!$v.form.conf.message.required" class="invalid-feedback">
                          {{ $t('form_live.tabs.required_message') }}
                        </div>
                      </div>
                      <!---- radio button video--->
                      <div class="form-group">
                        <b-form-radio
                          disabled
                          v-model="form.conf.type"
                          value="Video"
                          v-has-permission="'lives_conf_video_option'"
                          has-permission="lives_conf_video_option"
                          >{{ $t('form_live.tabs.configuration.form.video.title') }}
                          <span
                            class=" position-icon icon-infos "
                            v-b-tooltip.hover.right
                            :title="$t('form_live.tabs.configuration.form.infos.video')"
                          >
                          </span>
                        </b-form-radio>
                        <div v-if="!isBeforeLiveVideoPickerVisible && form.conf.type === 'Video'">
                          <div class="before-live-video-container">
                            <figure>
                              <div class="before-live-video-container__overlay">
                                <font-awesome-icon icon="play-circle"></font-awesome-icon>
                              </div>
                              <button
                                class="btn btn-sm before-live-video-container__btn"
                                @click="toggleBeforeLiveVideoPicker"
                              >
                                <font-awesome-icon icon="pencil-alt"></font-awesome-icon>
                                Changer la source
                              </button>
                              <b-img
                                :src="form.videoBeforeLive.logo"
                                fluid
                                :alt="form.videoBeforeLive.title"
                              ></b-img>
                            </figure>
                            <h5>{{ form.videoBeforeLive.title }}</h5>
                          </div>
                        </div>
                        <div class="mb-4">
                          <input
                            type="text"
                            v-model="form.conf.video"
                            class="form-control"
                            required
                            hidden
                          />
                          <div
                            class="video-picker-wrapper"
                            v-if="
                              form.conf.type === 'Video' &&
                                initInfinitScrollVideos &&
                                isBeforeLiveVideoPickerVisible
                            "
                          >
                            <div class="search-wrapper position-relative">
                              <input
                                :placeholder="
                                  $t('form_live.tabs.configuration.form.video.description')
                                "
                                type="text"
                                class="form-control mb-15"
                                @keyup.enter="searchVideo"
                                v-model="searchVideoKeyword"
                              />
                              <b-button
                                size="sm"
                                @click="searchVideo"
                                variant="light"
                                class="inline-submit-btn"
                              >
                                <font-awesome-icon icon="search"></font-awesome-icon>
                              </b-button>
                            </div>
                            <div class="video-slides-wrapper">
                              <VuePerfectScrollbar
                                ref="ps"
                                class="scroll-area"
                                @ps-y-reach-end="handlePageChanged"
                              >
                                <b-row>
                                  <b-col
                                    lg="2"
                                    md="3"
                                    sm="4"
                                    class="slide-wrapper"
                                    v-for="(slide, index) in slidesChips"
                                    :key="slide.id"
                                  >
                                    <div class="mb-3">
                                      <figure>
                                        <div
                                          class="video-overlay"
                                          :class="{ in: slide.id === form.conf.video }"
                                        >
                                          <button
                                            class="btn"
                                            @click="selectVideo(slide)"
                                            :class="
                                              slide.id === form.conf.video
                                                ? 'btn-light'
                                                : 'btn-outline-light'
                                            "
                                          >
                                            {{ $t('parameters.select.selectOption') }}
                                          </button>
                                        </div>
                                        <b-img
                                          :src="slide.thumbnail"
                                          fluid
                                          :alt="slide.title"
                                        ></b-img>
                                      </figure>
                                      <div
                                        class="video-name"
                                        :class="{ selected: slide.id === form.conf.video }"
                                        :title="slide.title"
                                      >
                                        {{ slide.title }}
                                      </div>
                                    </div>
                                  </b-col>
                                </b-row>
                                <div v-if="isLoading('videos')">
                                  <div class="sk-circle">
                                    <div class="sk-circle1 sk-child"></div>
                                    <div class="sk-circle2 sk-child"></div>
                                    <div class="sk-circle3 sk-child"></div>
                                    <div class="sk-circle4 sk-child"></div>
                                    <div class="sk-circle5 sk-child"></div>
                                    <div class="sk-circle6 sk-child"></div>
                                    <div class="sk-circle7 sk-child"></div>
                                    <div class="sk-circle8 sk-child"></div>
                                    <div class="sk-circle9 sk-child"></div>
                                    <div class="sk-circle10 sk-child"></div>
                                    <div class="sk-circle11 sk-child"></div>
                                    <div class="sk-circle12 sk-child"></div>
                                  </div>
                                </div>
                                <h5
                                  v-if="isEndReached('videos') && slidesChips.length === 0"
                                  class="c-grey-700 font-weight-bolder m-3 text-center"
                                >
                                  Pas de vidéos
                                </h5>
                              </VuePerfectScrollbar>
                            </div>
                          </div>
                          <div v-if="!$v.form.conf.video.required" class="invalid-feedback">
                            {{ $t('form_live.tabs.pick_video') }}
                          </div>
                        </div>
                      </div>
                      <!---- radio button image--->
                      <div class="form-group" v-has-permission="'lives_conf_image_option'" has-permission="lives_conf_image_option">
                        <b-form-radio v-model="form.conf.type" value="Image" disabled
                          >{{ $t('form_live.tabs.configuration.form.image') }}
                          <span
                            class=" position-icon icon-infos secondary "
                            v-b-tooltip.hover.right
                            :title="$t('form_live.tabs.configuration.form.infos.image')"
                          >
                          </span>
                        </b-form-radio>
                      </div>
                      <b-row v-show="form.conf.type === 'Image'">
                        <b-col md="4" sm="12">
                          <b-form-group
                            :description="$t('form_live.tabs.general.form.description_image')"
                            label-for="before-live-thumbnail"
                          >
                            <thumbnail-cropper
                              :crop-img="form.conf.image"
                              @thumbnailUpdated="handleBeforeLivePosterUpdated"
                            ></thumbnail-cropper>
                          </b-form-group>
                        </b-col>
                        <b-col md="8" sm="12">
                          <div class="form-group">
                            <label for="before-live-image-description">{{
                              $t('form_live.tabs.configuration.form.text_before_live')
                            }}</label>
                            <textarea
                              v-model="form.conf.imageText"
                              class="form-control "
                              id="before-live-image-description"
                              :placeholder="$t('form_live.tabs.configuration.form.text')"
                              rows="5"
                            ></textarea>
                          </div>
                        </b-col>
                      </b-row>
                      <!---- radio button counter--->
                      <div class="form-group" v-has-permission="'lives_conf_counter_option'" has-permission="lives_conf_counter_option">
                        <b-form-radio v-model="form.conf.type" value="Counter" disabled>{{
                          $t('form_live.tabs.configuration.form.countdown')
                        }}</b-form-radio>
                      </div>
                      <!---- radio button station encoder--->
                      <!--<div-->
                      <!--class="form-group"-->
                      <!--v-has-permission="'lives_encoder_no_api,lives_conf_pearl_option'"-->
                      <!--&gt;-->
                      <!--<b-form-radio-->
                      <!--:disabled="hasPermission('lives_conf_post_add')"-->
                      <!--v-model="form.conf.type"-->
                      <!--value="Pearl"-->
                      <!--&gt;{{-->
                      <!--$t('form_live.tabs.frontOffice.configuration.personalized.pearl')-->
                      <!--}}</b-form-radio-->
                      <!--&gt;-->
                      <!--</div>-->
                    </div>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col>
                    <div class="form-group">
                      <label for="title" class=" secondary " >{{
                        $t('form_live.tabs.configuration.form.informations')
                      }}</label>
                      <b-row>
                        <b-col>
                          <div class="form-group">
                            <label for="title" class=" secondary"
                              >{{ $t('form_live.tabs.configuration.form.about') }}
                              <span
                                class=" position-icon icon-infos "
                                v-b-tooltip.hover.right
                                :title="$t('form_live.tabs.configuration.form.infos.about')"
                              >
                              </span>
                            </label>
                            <!-- todo integrate text editor component-->
                            <ckeditor
                              :editor="editor"
                              @ready="onReady"
                              @input="onAboutEditorInput($event)"
                              v-model="form.editor.dataAbout"
                              :value="form.editor.dataAbout"
                              :config="editorConfig"
                              :isEnabled="'false'"
                              disabled
                            ></ckeditor>
                          </div>
                        </b-col>
                      </b-row>
                    </div>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col>
                    <div class="form-group">
                      <label for="title" class=" secondary "
                        >{{ $t('form_live.tabs.configuration.form.contact') }}
                        <span
                          class=" position-icon icon-infos "
                          v-b-tooltip.hover.right
                          :title="$t('form_live.tabs.configuration.form.infos.contact')"
                        >
                        </span>
                      </label>

                      <b-row>
                        <b-col cols="6">
                          <div class="form-group">
                            <input
                              type="text"
                              v-model="form.contact.address"
                              id="address"
                              name="address"
                              :placeholder="$t('form_live.tabs.configuration.form.address')"
                              class="form-control input-address"
                              disabled
                            />
                          </div>
                        </b-col>
                        <b-col cols="6">
                          <div class="form-group">
                            <input
                              type="text"
                              v-model="form.contact.phone"
                              id="phone"
                              name="phone"
                              class="form-control input-phone"
                              :placeholder="$t('form_live.tabs.configuration.form.phone')"
                              disabled
                            />
                          </div>
                        </b-col>
                      </b-row>
                      <b-row>
                        <b-col cols="12">
                          <div class="form-group">
                            <input
                              type="email"
                              v-model="form.contact.email"
                              id="email"
                              name="email"
                              :placeholder="$t('form_live.tabs.configuration.form.email')"
                              class="form-control input-email"
                              disabled
                            />
                          </div>
                        </b-col>
                      </b-row>
                    </div>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col>
                    <div class="form-group">
                      <label for="title" class=" secondary"
                        >{{ $t('form_live.tabs.configuration.form.intervenants.title') }}
                        <span
                          class=" position-icon icon-infos "
                          v-b-tooltip.hover.right
                          :title="$t('form_live.tabs.configuration.form.infos.intervenants')"
                        >
                        </span>
                      </label>
                      <b-row>
                        <b-col>
                          <div
                            v-if="form.allIntervenants.length > 0"
                            class="form-group"
                            v-for="(item, index) in form.allIntervenants"
                            :key="index"
                          >
                            <div class="form-control intervenants">
                              <span class="intervenants-text" :id="'Intervenant-' + index">
                                {{ item.lastName }} {{ item.firstName }}</span
                              >
                              <div class="intervenants-icons">
                                <span class="icon-edit" @click="editIntervenant(item)"></span>
                                <span class="icon-trash" @click="removeIntervenant(item)"></span>
                              </div>
                            </div>
                          </div>
                          <b-row>
                            <b-col>
                              <div class="form-group add-intervenants-button">
                                <a  @click="openModalIntervenant" disabled>
                                  <span class="button-add">+</span>
                                  <span class="add-intervenants">{{
                                    $t('form_live.tabs.configuration.form.intervenants.add')
                                  }}</span>
                                </a>
                              </div>
                            </b-col>
                          </b-row>
                          <!-- todo  add modal add intervenants-->
                          <b-modal
                            id="modal-intervenants"
                            ref="modal"
                            :title="$t('form_live.tabs.configuration.form.intervenants.add')"
                            @hidden="resetModal"
                            @ok="handleOk"
                            size="lg"
                            centered
                            :header-bg-variant="headerBgVariant"
                            :ok-variant="okButtonBgVariant"
                            :ok-title="$t('button.add')"
                            :cancel-title="$t('button.cancel')"
                            :cancel-variant="headerBgVariant"
                            :footer-border-variant="'transparent'"
                            :footer-class="'footer-intervenant'"
                            :header-class="'header-intervenant'"

                          >
                            <form
                              :ref="'intervenant-form'"
                              @submit.stop.prevent="handleSubmitModal"
                              class="needs-validation"
                              :class="{ 'was-validated': $v.intervenant.$anyDirty, }"
                            >
                              <b-row>
                                <b-col cols="6">
                                  <b-form-group
                                    :state="nameState"
                                    :label="
                                      $t('form_live.tabs.configuration.form.intervenants.lastName')
                                    "
                                    required
                                    :invalid-feedback="
                                      $t(
                                        'form_live.tabs.required_message',
                                      )
                                    "
                                    label-class="primary required intervenant-modal"
                                    label-for="IntervenantLastName"
                                  >
                                    <b-form-input
                                      id="IntervenantLastName"
                                      v-model="intervenant.lastName"
                                      required
                                      :state="nameState"
                                      :placeholder="
                                        $t(
                                          'form_live.tabs.configuration.form.intervenants.lastName',
                                        )
                                      "
                                      class="intervenant-modal "
                                    ></b-form-input>
                                    <div v-if="!$v.intervenant.lastName" class="invalid-feedback">
                                      {{ $t('form_live.tabs.required_message') }}
                                    </div>
                                  </b-form-group>
                                </b-col>
                                <b-col cols="6">
                                  <b-form-group
                                    :state="nameState"
                                    :label="
                                      $t('form_live.tabs.configuration.form.intervenants.firstName')
                                    "
                                    required
                                    :invalid-feedback="
                                      $t(
                                        'form_live.tabs.required_message',
                                      )
                                    "
                                    label-for="IntervenantFirstName"
                                    label-class="primary required intervenant-modal"
                                  >
                                    <b-form-input
                                      id="IntervenantFirstName"
                                      v-model="intervenant.firstName"
                                      :state="nameState"
                                      :placeholder="
                                        $t(
                                          'form_live.tabs.configuration.form.intervenants.firstName',
                                        )
                                      "
                                      required
                                      class="intervenant-modal"
                                    ></b-form-input>
                                    <div v-if="!$v.intervenant.firstName" class="invalid-feedback">
                                      {{ $t('form_live.tabs.required_message') }}
                                    </div>
                                  </b-form-group>
                                </b-col>
                              </b-row>
                              <b-row>
                                <b-col cols="6">
                                  <b-form-group
                                    :state="nameState"
                                    :label="
                                      $t('form_live.tabs.configuration.form.intervenants.fonction')
                                    "
                                    label-for="IntervenantFonction"
                                    label-class="primary intervenant-modal"
                                  >
                                    <b-form-input
                                      id="IntervenantFonction"
                                      v-model="intervenant.fonction"
                                      :state="nameState"
                                      :placeholder="
                                        $t(
                                          'form_live.tabs.configuration.form.intervenants.fonction',
                                        )
                                      "
                                      class="intervenant-modal form-control"
                                    ></b-form-input>
                                  </b-form-group>
                                </b-col>
                                <b-col cols="6">
                                  <b-form-group
                                    :state="nameState"
                                    :label="
                                      $t('form_live.tabs.configuration.form.intervenants.email')
                                    "
                                    label-for="IntervenantEmail"
                                    label-class="primary intervenant-modal"
                                  >
                                    <b-form-input
                                      id="IntervenantEmail"
                                      v-model="intervenant.email"
                                      :state="nameState"
                                      :placeholder="
                                        $t('form_live.tabs.configuration.form.intervenants.email')
                                      "
                                      class="intervenant-modal form-control"
                                      :value="intervenant.email"
                                    ></b-form-input>
                                  </b-form-group>
                                </b-col>
                              </b-row>
                              <b-row>
                                <b-col>
                                  <div class="form-group">
                                    <label for="title" class="primary intervenant-modal">{{
                                      $t('form_live.tabs.configuration.form.intervenants.biography')
                                    }}</label>
                                    <!-- todo add text editor component -->
                                    <ckeditor
                                      :editor="editor"
                                      @ready="onReady"
                                      v-model="intervenant.bibliography"
                                      :value="intervenant.bibliography"
                                      :config="editorConfig"
                                      :isEnabled="'true'"
                                    ></ckeditor>
                                  </div>
                                </b-col>
                              </b-row>
                              <!--<template v-slot:modal-footer>-->
                              <!--<div class="w-100">-->
                              <!--<b-button-->
                              <!--variant="secondary"-->
                              <!--size="sm"-->
                              <!--class="float-right"-->
                              <!--@click="show=false"-->
                              <!--&gt;-->
                              <!--{{$t('form.close')}}-->
                              <!--</b-button>-->
                              <!--<b-button-->
                              <!--variant="primary"-->
                              <!--size="sm"-->
                              <!--class="float-right"-->
                              <!--@click="show=false"-->
                              <!--&gt;-->
                              <!--{{$t('form.save')}}-->
                              <!--</b-button>-->
                              <!--</div>-->
                              <!--</template>-->
                            </form>
                          </b-modal>
                        </b-col>
                      </b-row>
                    </div>
                  </b-col>
                </b-row>
              </div>
            </b-col>
            <b-col class="col-12 col-sm-12 col-xl-6">
              <div class="tabs-wrapper">
                <b-row>
                  <b-col>
                    <div class="form-group">
                      <label for="title" class=" primary ">{{
                        $t('form_live.tabs.configuration.form.send_invitations.title')
                      }}</label>
                      <b-row>
                        <b-col>
                          <div class="form-group">
                            <label for="title" class=" primary "
                              >{{
                                $t(
                                  'form_live.tabs.configuration.form.send_invitations.group_emails',
                                )
                              }}
                              <span
                                class=" position-icon icon-infos "
                                v-b-tooltip.hover.right
                                :title="$t('form_live.tabs.configuration.form.infos.group_emails')"
                              >
                              </span>
                            </label>


                            <multiselect
                              v-model="form.groupEmails"
                              :options="getSubscriptionGroupUsers"
                              :multiple="true"
                              track-by="id"
                              label="name"
                              key="id"
                              :taggable="true"
                              :close-on-select="true"
                              placeholder=""

                              :selected-label="$t('form_live.tabs.advanced.contributors.selected_item')"
                              @select="selectOneGroup"
                              @remove="deselectOneGroup"
                            >
                              <span slot="noResult">{{
                                $t('form_live.tabs.advanced.contributors.no_result')
                              }}</span>
                              <span slot="noOptions">{{
                                $t('form_live.tabs.advanced.contributors.no_options')
                              }}</span>
                              <template slot="singleLabel" slot-scope="{ option }">
                                <strong>{{ option.name }} </strong>
                              </template>

                              <template slot="option" slot-scope="{ option }">
                                <div :style="{ 'margin-left': option.index + 'em' }">
                                  {{ option.name }}
                                </div>
                              </template>
                            </multiselect>
                          </div>
                          <div class="ListMail" id="ListMail" v-if="show_list_mail">
                            <div class="header">
                              <div class="context">
                              <span class="text">{{currentNameGroup}}</span>
                                <button type="submit" @click="show_list_mail=false" class="fermer" > X  </button>
                              </div>
                            </div>
                                <div class="addmail">
                                  <form @submit.stop.prevent="addOneMail" class="add-mail-form">
                                  <b-form-input
                                    id="input-add-mail"
                                    placeholder=" Ajouter un email"
                                    class="input-add-mail"
                                    v-model="oneMail"
                                    type="email"
                                  ></b-form-input>
                                  <button class="icon-add" type="submit" > + </button>
                                  </form>
                                </div>
                                <div class="list-mail-to-add">
                                  <div class="onemail" v-for="(item, index) in listGroup"
                                  :key="index">
                                    <div class="mail">{{item.email}}</div>
                                    <div class="delete cursor" @click="deleteMailInGroup(item.email)"><i class="icon-trash "></i></div>

                                  </div>
                                </div>





                          </div>
                        </b-col>
                      </b-row>
                      <b-row>
                        <b-col>
                          <div class="form-group">
                            <label for="title" class=" primary "
                              >{{ $t('form_live.tabs.configuration.form.send_invitations.emails') }}
                              <!--<span-->
                              <!--class=" position-icon icon-infos "-->
                              <!--v-b-tooltip.hover.right-->
                              <!--:title="$t('form_live.tabs.configuration.form.infos.emails')"-->
                              <!--&gt;-->
                              <!--</span>-->
                            </label>
                            <input-tag
                              v-model="listMailInStor"
                              validate="email"
                              class="input-email"
                            ></input-tag>
                          </div>
                        </b-col>
                      </b-row>
                    </div>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col>
                    <div class="form-group">
                      <label for="title" class=" primary "
                        >{{ $t('form_live.tabs.configuration.form.send_rule.title') }}
                        <span
                          class=" position-icon icon-infos "
                          v-b-tooltip.hover.right
                          :title="$t('form_live.tabs.configuration.form.infos.send_rule')"
                        >
                        </span>
                      </label>
                    </div>
                    <div class="form-group">
                      <div v-if="form.rules.length > 0">
                        <b-row v-for="(rule, index) in form.rules" :key="index">
                          <b-col cols="2">
                            <input
                              type="number"
                              :id="'send-rule-' + index"
                              name="send rule"
                              class="form-control input-send"
                              :value="rule.nbDays"
                              @input="setNbDays($event, index)"
                            /><!-- -->
                          </b-col>
                          <b-col cols="3">
                            <span class="positions-text">{{
                              $t('form_live.tabs.configuration.form.send_rule.days_left')
                            }}</span>
                          </b-col>
                          <b-col cols="2">
                            <!-- todo integrate vue-clock-picker compoenent -->
                            <div
                              class="form-group beforeHour"

                            >
<!--                              :class="{ 'is-invalid__custom': $v.form.beforeHour.$invalid }"-->
                              <vue-clock-picker
                                :id="'beforeHour-' + index"
                                v-model="rule.beforeHour"
                                input-class="form-control before-hour-rule"
                                :value="rule.beforeHour"
                                :active-color="getActiveColor"
                                :required="false"
                                :cancel-text="$t('button.cancel')"
                                :done-text="$t('button.done')"
                                :close-on-overlay="closeOnOverlay"
                                @cancel="getClockValue($event, index)"
                              >
                              </vue-clock-picker>
<!--                              <div v-if="!$v.form.beforeHour.required" class="invalid-feedback">-->
<!--                                {{ $t('form_live.tabs.required_message') }}-->
<!--                              </div>-->
<!--                              <div-->
<!--                                v-else-if="!$v.form.beforeHour.minValue"-->
<!--                                class="invalid-feedback"-->
<!--                              >-->
<!--                                {{ $t('form_live.tabs.general.form.invalid_hour') }}-->
<!--                              </div>-->
                            </div>
                          </b-col>
                          <b-col cols="5" flex>
                            <div
                              class="form-group add-rule-button add-rule-button--position"
                              @click="addSendRule"
                              v-show="index === 0"
                            >
                              <a>
                                <span class="button-add">+</span>
                                <span class="add-rule">
                                  {{
                                    $t(
                                      'form_live.tabs.configuration.form.send_rule.add_rule_button',
                                    )
                                  }}</span
                                >
                              </a>
                            </div>
                          </b-col>
                        </b-row>
                      </div>
                    </div>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col>
                    <div class="form-group">
                      <label for="title" class=" secondary conf-label "
                        >{{ $t('form_live.tabs.configuration.form.encoding.title') }}
                        <span
                          class=" position-icon icon-infos  "
                          v-b-tooltip.hover.right
                          :title="$t('form_live.tabs.configuration.form.infos.encoding')"
                        >
                        </span>
                      </label>
                      <b-row>
                        <b-col>
                          <div class="form-group">
                            <label for="title" class=" secondary conf-label" >{{
                              $t('form_live.tabs.configuration.form.encoding.url')
                            }}</label>
                            <b-row>
                              <b-col>
                                <!-- todo recap url flux encoding -->
                                <div class="encoding-url">
                                  <input
                                    disabled
                                    type="text"
                                    v-model="form.encodingUrl"
                                    id="encoding-url"
                                    name="encoding url"
                                    class="form-control conf-label input-encoding-url"
                                  />
                                  <button
                                    disabled
                                    @click="copyButton($event, 'encoding-url')"
                                    class="btn btn-secondary copy-button"
                                  >
                                    {{ $t('button.copy') }}
                                  </button>
                                </div>
                              </b-col>
                            </b-row>
                          </div>
                        </b-col>
                      </b-row>
                      <b-row>
                        <b-col>
                          <div class="form-group">
                            <label for="title" class=" secondary conf-label" >{{
                              $t('form_live.tabs.configuration.form.encoding.name')
                            }}</label>
                            <b-row>
                              <b-col>
                                <!-- todo recap name flux encoding -->
                                <div class="encoding-url">
                                  <input
                                    disabled
                                    type="text"
                                    v-model="form.encodingName"
                                    id="encoding-name"
                                    name="encoding url"
                                    class="form-control conf-label input-encoding-name"
                                  />
                                  <button
                                    disabled
                                    @click="copyButton($event, 'encoding-name')"
                                    class="btn btn-secondary copy-button"
                                  >
                                    {{ $t('button.copy') }}
                                  </button>
                                </div>
                              </b-col>
                            </b-row>
                          </div>
                        </b-col>
                      </b-row>
                      <b-row>
                        <b-col>
                          <div class="form-group">
                            <label for="title" class=" secondary conf-label" >{{
                              $t('form_live.tabs.configuration.form.encoding.key')
                            }}</label>
                            <b-row>
                              <b-col>
                                <!-- todo recap key flux encoding -->
                                <div class="encoding-url">
                                  <input
                                    disabled
                                    type="text"
                                    v-model="form.encodingKey"
                                    id="encoding-key"
                                    name="encoding url"
                                    class="form-control conf-label input-encoding-key"
                                  />
                                  <button
                                    disabled
                                    @click="copyButton($event, 'encoding-key')"
                                    class="btn btn-secondary copy-button"
                                  >
                                    {{ $t('button.copy') }}
                                  </button>
                                </div>
                              </b-col>
                            </b-row>
                          </div>
                        </b-col>
                      </b-row>
                    </div>
                  </b-col>
                </b-row>
              </div>
            </b-col>
          </b-row>
        </div>

        <!--</div>-->
      </b-form>
<!--      <div class="buttons-wrapper d-none d-lg-block">-->
<!--        <b-button variant="light" type="button" class="mr-2" @click="goToListLive">{{-->
<!--          $t('button.cancel')-->
<!--        }}</b-button>-->
<!--        <b-button-->
<!--          variant="primary"-->
<!--          type="submit"-->
<!--          @mousedown="submitForm"-->
<!--          :disabled="$v.form.$error"-->
<!--          >{{ $t('button.save') }}</b-button-->
<!--        >-->
<!--      </div>-->
    </b-container>
    <b-modal
      :title="$t('startDirect.title')"
      id="modal-start-direct-v2"
      ref="modal-start-direct-v2"
      :header-bg-variant="customheaderBgVariant"
      hide-footer
      size="lg"
    >

      <div class="subTitle"> {{ $t('startDirect.subtitle') }} </div>

      <div class="action-start-direct">
        <b-button
          @click="redirectTo(true)"
          variant="primary"
          type="button"
          class="mr-2"
        >{{ $t('startDirect.btn.YES') }}</b-button>
        <b-button variant="light" type="button"  @click="redirectTo()">{{ $t('startDirect.btn.NO') }}</b-button>

      </div>
      <div class="action-choix">
        <div class="form-group">
          <b-form-checkbox
            v-model="status"
          >
            {{ $t('startDirect.choix') }}
          </b-form-checkbox>
        </div>
      </div>

    </b-modal>
  </div>
</template>

<script>
import Datepicker from 'vue2-datepicker';
import axios from 'axios';
// import * as lang from 'vuejs-datepicker/src/locale';

import VueClockPicker from '@pencilpix/vue2-clock-picker';
import InputTag from 'vue-input-tag';
import vue2Dropzone from 'vue2-dropzone';
import VuePerfectScrollbar from 'vue-perfect-scrollbar';
import Multiselect from 'vue-multiselect';
import draggable from 'vuedraggable';

import { required, requiredIf } from 'vuelidate/lib/validators';
import { Carousel, Slide } from 'vue-carousel';
import { mapGetters, mapActions } from 'vuex';

import ThumbnailCropper from '@/components/components/ThumbnailCropper';
import QuestionForm from '@/components/components/QuestionForm';
import UploadMixin from '../mixins/UploadMixin.js';
import UtilsMixin from '../mixins/UtilsMixin.js';
import HasPermission from '../directives/HasPermission.js';

import common from '../helpers/common';
import {
  getLiveDocumentsHeaders,
  getSignedLiveDocumentsUrl,
  getLiveDocumentId,
  getLiveDocumentName,
  getLiveDocumentUrl,
  isLiveDocumentPublic,
  normalizeLiveDocumentsResponse,
} from '../helpers/live-documents';
import NProgress from 'nprogress';
import InfiniteLoading from 'vue-infinite-loading';
import VueTimepicker from 'vue2-timepicker'

import i18n from '../i18n/index.js';
import en from '../i18n/en_US';
import fr from '../i18n/fr_FR';
import ckEditor from '@ckeditor/ckeditor5-vue';
import DecoupledEditor from '@ckeditor/ckeditor5-build-decoupled-document';
//import UploadAdapter from '@ckeditor/ckeditor5-adapter-ckfinder/src/uploadadapter';
//import SimpleUploadAdapter from '@ckeditor/ckeditor5-upload/src/adapters/simpleuploadadapter';

import Routing from '../core/router/router';
import { HTTP } from '../core/http/http-token';

var moment = require('moment');
export default {
  name: 'LiveForm',
  mixins: [UploadMixin, UtilsMixin],
  components: {
    Datepicker,
    VueClockPicker,
    InputTag,
    QuestionForm,
    VuePerfectScrollbar,
    Carousel,
    Slide,
    Multiselect,
    draggable,
    ThumbnailCropper,
    vueDropzone: vue2Dropzone,
    InfiniteLoading,
    ckeditor: ckEditor.component,
    VueTimepicker,
  },
  i18n: {
    messages: {
      en: en,
      fr: fr,
    },
  },
  directives: {
    HasPermission,
  },
  validations: {
    form: {
      title: { required },
      description: { required },
      /*duration: {
        required: requiredIf(function(nestedModel) {
          return this.show_start_date;
        })
      },*/
      startDate: {
        required: requiredIf(function(nestedModel) {
          return this.show_start_date;
        }),
        // minValue: value => {
        //   const today = new Date();
        //   let yesterday = new Date();
        //   yesterday.setDate(today.getDate() - 1);
        //
        //   if(!this.show_start_date){
        //     return true
        //   }else{
        //   return new Date(value) > yesterday;
        //   }
        // },
      },
      startTime: {
        required: requiredIf(function(nestedModel) {
          return this.show_start_date;
        }),
        // minValue(value) {
        //   if(!this.show_start_date){
        //     return true
        //   }else{
        //     if (moment().isSame(this.form.startDate, 'day')) {
        //       const beginningTime = moment(this.form.startTime, 'HH:mm');
        //       return moment().isBefore(beginningTime);
        //     }
        //     return true;
        //   }
        // },
      }
     /* beforeHour: {
        required: requiredIf(function(nestedModel) {
          return this.show_start_date;
        }),
        minValue(value) {
          if (moment().isSame(this.form.beforeHour, 'day')) {
            const beginningTime = moment(this.form.beforeHour, 'HH:mm');
            return moment().isBefore(beginningTime);
          }
          return true;
        },
      }*/,
     /* endTime: {
        required: requiredIf(function(nestedModel) {
          return this.show_start_date;
        }),
        minValue(value) {
          const endTime = moment(value, 'HH:mm', true);
          const startTime = moment(this.form.startTime, 'HH:mm', true);

          if(!this.show_start_date){
            return true
          }else{
          return endTime > startTime;}
        },
      },*/
      conf: {
        message: {
          required: requiredIf(function(nestedModel) {
            return this.form.conf.type === 'Message';
          }),
        },
        video: {
          required: requiredIf(function(nestedModel) {
            return this.form.conf.type === 'Video';
          }),
        },
      },
      survey: {
        required: requiredIf(function(nestedModel) {
          return this.form.foSondage;
        }),
      },
    },
    intervenant:{
      lastName: { required },
      firstName: { required },
    }
  },
  data() {
    return {
      currentNameGroup:null,
      currentIdGroup:null,
      oneMail:null,
      show_list_mail:false,
      show_start_date:true,
      show_automatic_archiving:false,
      customheaderBgVariant: 'custom-secondary',
      status: false,
      currentLive:{},
      imgSrc: '',
      cropImg: '',
      form: {
        duration:null,
        title: '',
        description: '',
        startDate: new Date(),
        startTime: moment().format('HH:mm'),
        endTime:  moment()
          .add(1, 'hours')
          .format('HH:mm'),
        tags: [],
        isCdn: true,
        screenShare: false,
        webinar: true,
        screenType: 'pip',
        chapters: [],
        questions: [],
        files: [],
        foFilesShare: false,
        slides: [],
        defaultConf: true,
        secureAccess : false,
        conf: {
          type: null,
        },
        diffusion: 'webinar',
        videoBeforeLive: null,
        autoPub: false,
        shareLive: '',
        contact: {
          email: '',
          phone: '',
          address: '',
        },

        allIntervenants: [],
        editor: {
          dataAbout: '',
        },
        idTemplate: 0,
        encodingUrl: 'test',
        encodingName: 'test',
        encodingKey: 'test',
        nbDays: 1,
        beforeHour: moment().format('HH:mm'),
        emails: [],
        groupEmails: [],
        doc_public: false,
        autoSip: false,
        rules: [
          {
            nbDays: 1,
            beforeHour: moment().format('HH:mm'),
          },
        ],
      },
      intervenant: {
        lastName: '',
        firstName: '',
        fonction: '',
        bibliography: '',
        email: '',
      },
      searchVideoKeyword: '',
      submitButtonClicked: false,
      requiredMessage: i18n.t('form_live.tabs.required_message'),
      screenTypeOptions: [
        { value: 'pip', text: 'Picture in Picture PIP' },
        { value: 'sbs', text: 'Side by Side' },
      ],
      newChapter: '',
      currentPageQuestion: 1,
      addQuestionMode: false,
      showAllSlides: false,
      joinFile: false,
      socialNetwork: false,
      password: false,
      //languages: lang,
      initialLocaleCode: 'fr',
      isEditMode: false,
      slideIndex: -1,
      showCarousel: false,
      ready: false,
      pastDates: {},
      isBeforeLiveVideoPickerVisible: true,
      initInfinitScrollVideos: false,
      chapterTitle: '',
      shortcuts: [
        {
          text: 'Today',
          onClick: () => {
            this.time3 = [new Date(), new Date()];
          },
        },
      ],
      disabledConfigFO: false,
      tabs: ['general', 'configuration'],
      activeTab: 'general',
      allTemplates: [],
      isSelectedTheme: false,
      showMoreTemplates: false,
      showLessTemplates: false,
      showText: 'more',
      nb_rest: 0,
      nameState: null,
      headerBgVariant: 'header-secondary',
      okButtonBgVariant: 'primary',
      editor: DecoupledEditor,
      editorConfig: {
      },
      showLiveToolip: false,
        showErrorMessage: false,
      liveDocuments: [],
      pendingLiveDocuments: [],
      documentsLoading: false,
      documentsUploading: false,
      documentsDeletingId: null,
    };
  },
  computed: {
    ...mapGetters({
      live: 'lives/getSelected',
      contributorsOptions: 'lives/getContributors',
      channelsOptions: 'lives/getChannels',
      surveyOptions: 'form/getSurveys',
      slidesChips: 'form/getVideos',
      isEndReached: 'form/getEndReached',
      isLoading: 'form/getLoading',
      hasPermission: 'common/hasPermission',
      getDiffusion: 'common/getDiffusion',
      getDiffusionObject: 'lives/getDiffusionObject',
      getAllSkinTemplates: 'lives/getAllSkinTemplates',
      getSubscriptionUser: 'lives/getSubscriptionUser',
      getSubscriptionGroupUsers: 'lives/getSubscriptionGroupUsers',
      isGroupExist:'lives/isGroupExist',
      getlistMail:'lives/getlistMail',
      getGroupById:'lives/getGroupById'
    }),
    isEmpreinteClient() {
      return window.process.env.CLIENT_NAME === 'empreinte';
    },
      getDifferentDiffusionPermission(){
          let permissions=[
              {name:"webinar",permission:"lives_webinar_no_api"},
              {name:"isPearl",permission:"lives_encoder_no_api"},
              {name:"screenShare", permission:"lives_screen_share_no_api"}
          ]
          let permissionsArray = [];
          permissions.forEach((p)=>{
              if(this.hasPermission(p.permission)){
                  permissionsArray.push(p);
              }
              this.form[p.name] = false;
              return p.permission
          })
          if(permissionsArray.length> 0 && permissionsArray.length===1){
              this.form.diffusion=permissionsArray[0].name;
              this.form[permissionsArray[0].name] = true;
          }else{
              this.form[permissions[0].name] = true;
          }

      },
      getDiffusionPermission(){
          if(this.currentLive.isPearl){
              return "lives_pearl_diffuser_no_api"
          }else{
              return "lives_diffuser_no_api"
          }
      },
    listMailInStor:{
      get () {
        return this.getlistMail
      },
      set (value) {
        //add and edit ListMail from TagInput in same Store
        this.setListMail(value)
      }
    },

    templates() {
      if (this.getAllSkinTemplates && Object.keys(this.getAllSkinTemplates).length > 0) {
        this.allTemplates = this.getAllSkinTemplates.filter(theme => theme.type === 'live');
      }
      let allThemes = [];
      this.allTemplates.forEach((template, index) => {
        if (index > 2 && !this.showMoreTemplates) {
          return;
        } else {
          if (allThemes.indexOf(template) === -1) {
            allThemes.push(template);
          }
        }
      });
      this.nb_rest = this.allTemplates.length - 3;
      return allThemes;
    },

    isChapterEditMode() {
      return this.form.chapters.some(c => c.isEditMode);
    },
    isQuestionEditMode() {
      return this.form.questions.some(c => c.isEditMode);
    },
    getActiveColor() {
      return common.getSafeColor(this.$route.query.color);
    },
    themesOptions() {
      return this.mapThemes(this.channelsOptions);
    },
    closeOnOverlay() {
      return true;
    },
    managedLiveDocuments() {
      return this.$route.params.id ? this.liveDocuments : this.pendingLiveDocuments;
    },
  },
  watch: {
    live() {
      this.ready = true;
      this.form = JSON.parse(JSON.stringify(this.live));
      this.form.doc_public = !!this.form.doc_public;
      this.socialNetwork = this.form.foFacebook || this.form.foTwitter || this.form.foWisembly;
      this.joinFile = this.form.files.length > 0;
      this.password = !!this.form.pwd;
      this.isBeforeLiveVideoPickerVisible = !this.form.videoBeforeLive;
      console.log("back api live :",this.form )
    },
  },
  methods: {
    ...mapActions('lives', ['addIntoListGroup']),
    ...mapActions('common', ['setDiffusionLive']),
    ...mapActions('lives', [
      'getLiveById',
      'fetchContributors',
      'fetchChannels',
      'fetchLiveTypes',
      'updateLive',
      'createLive',
      'setDiffusionObject',
      'fetchAllSkinTemplates',
      'resetAllSkinTemplates',
      'getSubscriptionUserList',
      'getSubscriptionGroupUsersList',
      'deleteOneMailIntoListMail',
      'addOneMailIntoGroup',
      'addIntoListMail',
      'deleteOneMailIntoGroup',
      'deleteGroupMailFromListMail',
      'setListMail',

    ]),
    ...mapActions('form', ['fetchVideos', 'fetchSurveys', 'resetPagination']),
    // addGroupUser(group) {
    //   console.log('event*****', group);
    //   this.form.groupMails.push(group.name);
    // },

    format(value, event) {
      return moment(value).format('YYYY-MM-DDThh:mm:ss').tz('Europe/Rome')
    },

    deselectOneGroup(){
      this.deleteGroupMailFromListMail(this.currentIdGroup)
      this.show_list_mail=false;
    },
      removeError(event){
          if(event.target.value.length >=255 ){
              this.showErrorMessage=true;
          }else{
              this.showErrorMessage=false;
          }
      },
    async selectOneGroup(Obj){
      //call api if group not exist in List Group
      if(!this.isGroupExist(Obj.id)){
        await this.addIntoListGroup(Obj.id);
      }
      this.currentNameGroup=Obj.name;
      this.currentIdGroup=Obj.id;
      this.listGroup=this.getGroupById(Obj.id).users;
      this.listGroup.forEach(e=>{
        this.addIntoListMail(e.email );
      })

      this.show_list_mail=true;
    },
    deleteMailInGroup(email){
      let data={id:this.currentIdGroup,email:email}
      this.deleteOneMailIntoGroup(data);
      this.deleteOneMailIntoListMail(email);
      this.listGroup=this.getGroupById(this.currentIdGroup).users
    },

    addOneMail(){
      if(this.oneMail){
     let data={id:this.currentIdGroup,email:this.oneMail};
     this.addOneMailIntoGroup(data);
     this.addIntoListMail(this.oneMail);}
     this.oneMail=null
    },
    redirectTo(start){
      if(start){
        parent.postMessage(
          {
            info:'goToDiffusionLive' ,
            live: this.currentLive,
          },
          '*',
        );
        this.$root.$emit('bv::hide::modal', 'modal-start-direct-v2');

      }else {
        this.goToListLive();
      }

      if(this.status && start){
        localStorage.setItem('redirectToStartDirect',true);
      }else if(this.status && !start){
        localStorage.setItem('redirectToList',true);
      }

    },



    setNbDays(event, index) {
      console.log('event****', event);
      console.log('index****', index);
      console.log('his.rules[index]****', this.form.rules[index]);
      this.form.rules[index].nbDays = event.target.value;
    },
    getClockValue(event, index) {
      console.log('event****', event);
      this.form.rules[index].beforeHour = event.target.value;
    },
    onReady(editor) {
      // Insert the toolbar before the editable area.
      editor.ui
        .getEditableElement()
        .parentElement.insertBefore(editor.ui.view.toolbar.element, editor.ui.getEditableElement());
    },
    onAboutEditorInput(event) {
      this.form.editor.dataAbout = event;
    },
    // onIntervenantEditorInput(event) {
    //   this.form.editor.dataIntervenant = event;
    // },
    checkFormValidity() {
      let valid = this.$refs['intervenant-form'].checkValidity();
      console.log('valid*****',valid)
      let validators=['lastName','firstName'];
      if( validators.some(item => this.$v.intervenant[item].$invalid)) {
        valid=false;
      }
      this.nameState = valid;
      return valid;
    },
    resetModal() {
      this.intervenant = {
        lastName: '',
        firstName: '',
        fonction: '',
        bibliography: '',
        email: '',
      };
      this.nameState = true;
    },
    openModalIntervenant(){
      this.nameState = true;
    },
    editIntervenant(intervenant) {
      this.intervenant = intervenant;
      console.log(' this.intervenant**', this.intervenant);
      this.$bvModal.show('modal-intervenants');
    },
    removeIntervenant(intervenant) {
      let message_confirm = i18n.t('toast.success_delete');
      let message_reset = i18n.t('modal.delete.selection.btn_cancel');
      const TOAST_DURATION = 5000;
      const TOAST_DURATION_DELETE = TOAST_DURATION + 1;
      let deleteLive = true
      let index = this.form.allIntervenants.indexOf(intervenant);
      this.form.allIntervenants.splice(index, 1);
      this.$toasted.show(message_confirm, {
        theme: 'bubble',
        position: 'bottom-right',
        icon: {
          name: 'icon-warning mr-2',
        },
        duration: TOAST_DURATION,
        action: {
          text: message_reset,
          onClick: (e, toastObject) => {
            deleteLive = false;
            this.form.allIntervenants.push(intervenant)
            toastObject.goAway(0);
          },
        },
      });
      setTimeout(() => {

      }, TOAST_DURATION_DELETE);

    },
    handleOk(bvModalEvt) {
      // Prevent modal from closing
      bvModalEvt.preventDefault();
      // Trigger submit handler
      console.log("this.$v.form.$error",this.$v.form)
      this.$v.intervenant.$touch();
      if (this.$v.intervenant.$error) {
        this.highlightFormErrors();
        return;
      }
      this.handleSubmitModal();
    },
    handleSubmitModal() {
      // Exit when the form isn't valid
      if (!this.checkFormValidity()) {
        return;
      }
      // Push the name to submitted names
      console.log('this.form.allIntervenants.indexOf(this.intervenant) ***',this.form.allIntervenants.indexOf(this.intervenant) )
      if(this.form.allIntervenants.indexOf(this.intervenant) === -1)
      this.form.allIntervenants.push(this.intervenant);
      // Hide the modal manually
      this.$nextTick(() => {
        this.$bvModal.hide('modal-intervenants');
      });
    },
    addSendRule() {
      let rule = {
        nbDays: 1,
        beforeHour: moment().format('HH:mm'),
      };

      this.form.rules.push(rule);
      console.log('this.form.rules***', this.form.rules);
    },
    copyButton(event, selector) {
      console.log('event', event);
      var copyText = document.getElementById(selector);
      copyText.select();
      copyText.setSelectionRange(0, 99999);
      document.execCommand('copy');
    },
    changeTab(tab) {
      this.activeTab = tab;
    },
    selectTheme(theme) {
      this.isSelectedTheme = true;
      this.form.idTemplate = theme.id;
    },
    showMore() {
      this.showMoreTemplates = !this.showMoreTemplates;
      if (this.showMoreTemplates) {
        this.showText = 'less';
      } else {
        this.showText = 'more';
      }

      // this.showLessTemplates = true;
    },
    async handleSubmit() {
      console.log('handleSubmit', this.submitButtonClicked);
      if (!this.submitButtonClicked) {
        return;
      }
      this.submitButtonClicked = false;
      this.resetHighlightErrors();

      console.log("this.$v.form.$error",this.$v.form)
      this.$v.form.$touch();
      if (this.$v.form.$error) {
        this.highlightFormErrors();
        return;
      }
      NProgress.start();
      console.log('this.form', this.form);
      if(!this.form.duration || this.form.duration===null){
        this.form.endTime="01:00"
      }

      if(this.form.duration != null && this.form.duration){
        if(this.form.duration.HH == "" && this.form.duration.mm != "" ){
          this.form.duration= "00:"+this.form.duration.mm
        }
        if(this.form.duration.mm == "" && this.form.duration.HH != ""){
          this.form.duration= this.form.duration.HH +":00"
        }

      }

      this.form.emails=this.listMailInStor;

      let dataToSubmit = this.mapFormData(this.form);
      console.log('dataToSubmit', dataToSubmit);
      let message;
      let data;
      try {
        if (this.isEditMode) {
          data = await this.updateLive(dataToSubmit);
          message = i18n.t('toast.success_edit');
        } else {
          data = await this.createLive(dataToSubmit);
          await this.uploadPendingLiveDocuments(data.Lives.id);
          message = i18n.t('toast.success_add');
        }
        this.showToast('success', message, 'icon-success');
      } catch (e) {
        message = i18n.t('toast.error');
        this.showToast('error', message, 'icon-warning');
      }

      let startdate = moment(new Date(dataToSubmit.empLivesForm.dateStart)).format('YYYY-MM-DD');
      let currentdate = moment(new Date()).format('YYYY-MM-DD');
      let choixOUI = localStorage.getItem('redirectToStartDirect');
      let choixNON = localStorage.getItem('redirectToList');
      if(startdate === currentdate && !choixOUI  && !choixNON ) {
        console.log("data",data)
        this.currentLive = data.Lives;
          if( this.hasPermission(this.getDiffusionPermission) ){
              this.$root.$emit('bv::show::modal', 'modal-start-direct-v2');
          }else{
              this.goToListLive();
          }
      }else{
        this.$v.form.$reset();
        var obj = this.getDiffusionObject;
        obj.type =this.getDiffusion;
        this.setDiffusionObject(obj);
        this.setDiffusionLive(this.getDiffusion);
        this.goToListLive();
      }

      NProgress.done();
    },
    getManagedDocumentName(item) {
      return getLiveDocumentName(item);
    },
    getManagedDocumentUrl(item) {
      return getLiveDocumentUrl(item);
    },
    isManagedDocumentPublic(item) {
      return isLiveDocumentPublic(item);
    },
    getManagedDocumentId(item) {
      return getLiveDocumentId(item);
    },
    triggerLiveDocumentUpload() {
      if (this.$refs.liveDocumentsInput) {
        this.$refs.liveDocumentsInput.click();
      }
    },
    async fetchLiveDocuments() {
      if (!this.$route.params.id) {
        this.liveDocuments = [];
        return;
      }

      this.documentsLoading = true;

      try {
        const signedUrl = await getSignedLiveDocumentsUrl(`/live/file-live/${this.$route.params.id}`);
        const response = await axios.get(signedUrl, getLiveDocumentsHeaders());
        this.liveDocuments = normalizeLiveDocumentsResponse(response);
      } catch (error) {
        console.log('error while fetching live documents : ', error);
        this.liveDocuments = [];
        this.showToast(
          'error',
          this.$t('form_live.tabs.advanced.documents.fetch_error'),
          'icon-warning',
        );
      } finally {
        this.documentsLoading = false;
      }
    },
    async handleLiveDocumentFileChange(event) {
      const input = event && event.target ? event.target : null;
      const files = input && input.files ? Array.from(input.files) : [];

      if (!files.length) {
        if (input) {
          input.value = '';
        }
        return;
      }

      if (!this.$route.params.id) {
        files.forEach((file, index) => {
          this.pendingLiveDocuments.push({
            localId: `pending-document-${Date.now()}-${index}`,
            name: file.name,
            file,
            isPending: true,
            public: !!this.form.doc_public,
          });
        });
        this.showToast(
          'success',
          this.$t('form_live.tabs.advanced.documents.queued_success'),
          'icon-success',
        );
        if (input) {
          input.value = '';
        }
        return;
      }

      this.documentsUploading = true;

      try {
        for (const file of files) {
          await this.uploadLiveDocument(file, this.$route.params.id, !!this.form.doc_public);
        }

        this.showToast(
          'success',
          this.$t('form_live.tabs.advanced.documents.upload_success'),
          'icon-success',
        );
        await this.fetchLiveDocuments();
      } catch (error) {
        console.log('error while uploading live documents : ', error);
        this.showToast(
          'error',
          this.$t('form_live.tabs.advanced.documents.upload_error'),
          'icon-warning',
        );
      } finally {
        this.documentsUploading = false;
        if (input) {
          input.value = '';
        }
      }
    },
    async uploadLiveDocument(file, liveId, publishAfterUpload = false) {
      const signedUrl = await getSignedLiveDocumentsUrl(`/live/files-live/${liveId}`);
      const formData = new FormData();
      formData.append('file', file);
      formData.append('owner', window.client || window.process.env.CLIENT_NAME || 'empadmin');

      const response = await axios.post(signedUrl, formData, getLiveDocumentsHeaders(null));
      const uploadedDocuments = normalizeLiveDocumentsResponse(response);

      if (publishAfterUpload) {
        const ids = uploadedDocuments.map(item => getLiveDocumentId(item)).filter(Boolean);
        if (ids.length > 0) {
          await this.setLiveDocumentsPublish(ids, true);
        }
      }

      return response;
    },
    async uploadPendingLiveDocuments(liveId) {
      if (!liveId || this.pendingLiveDocuments.length === 0) {
        return;
      }

      this.documentsUploading = true;

      try {
        for (const pendingDocument of this.pendingLiveDocuments) {
          await this.uploadLiveDocument(
            pendingDocument.file,
            liveId,
            !!pendingDocument.public,
          );
        }

        this.pendingLiveDocuments = [];
        await this.fetchLiveDocuments();
      } finally {
        this.documentsUploading = false;
      }
    },
    async setLiveDocumentsPublish(ids, value) {
      if (!Array.isArray(ids) || ids.length === 0) {
        return;
      }

      const signedUrl = await getSignedLiveDocumentsUrl('/live/files-live/publish');
      await axios.post(
        signedUrl,
        [{ ids, public: !!value }],
        getLiveDocumentsHeaders('application/json'),
      );
    },
    async toggleLiveDocumentPublish(document, value) {
      const documentId = this.getManagedDocumentId(document);
      if (!documentId) {
        return;
      }

      try {
        await this.setLiveDocumentsPublish([documentId], value);
        this.liveDocuments = this.liveDocuments.map(item =>
          this.getManagedDocumentId(item) === documentId ? { ...item, public: !!value } : item,
        );
      } catch (error) {
        console.log('error while updating live document visibility : ', error);
        this.showToast(
          'error',
          this.$t('form_live.tabs.advanced.documents.publish_error'),
          'icon-warning',
        );
      }
    },
    async deleteLiveDocument(document) {
      const documentId = document.isPending ? document.localId : this.getManagedDocumentId(document);
      if (!documentId) {
        return;
      }

      if (document.isPending) {
        this.pendingLiveDocuments = this.pendingLiveDocuments.filter(
          item => item.localId !== documentId,
        );
        return;
      }

      this.documentsDeletingId = documentId;

      try {
        const signedUrl = await getSignedLiveDocumentsUrl(`/live/file-live/${documentId}`);
        await axios.delete(signedUrl, getLiveDocumentsHeaders());
        this.liveDocuments = this.liveDocuments.filter(
          item => this.getManagedDocumentId(item) !== documentId,
        );
        this.showToast(
          'success',
          this.$t('form_live.tabs.advanced.documents.delete_success'),
          'icon-success',
        );
      } catch (error) {
        console.log('error while deleting live document : ', error);
        this.showToast(
          'error',
          this.$t('form_live.tabs.advanced.documents.delete_error'),
          'icon-warning',
        );
      } finally {
        this.documentsDeletingId = null;
      }
    },
    async copyLiveDocumentLink(document) {
      const url = this.getManagedDocumentUrl(document);
      if (!url) {
        return;
      }

      try {
        await navigator.clipboard.writeText(url);
        this.showToast(
          'success',
          this.$t('form_live.tabs.advanced.documents.link_copied'),
          'icon-success',
        );
      } catch (error) {
        console.log('error while copying live document link : ', error);
      }
    },
    onReset() {},
    handleToggleSecured() {
      if (!this.password) {
        this.form.pwd = '';
      } else {
        this.form.pwd = this.generatePassword();
      }
    },

    toggleBeforeLiveVideoPicker() {
      this.isBeforeLiveVideoPickerVisible = !this.isBeforeLiveVideoPickerVisible;
    },
    focusAddChapter() {
      this.$nextTick(() => {
        if (this.$refs.newChapterInput) {
          this.$refs.newChapterInput.$el.focus();
        }
      });
    },
    highlightFormErrors() {

      var validators = [['description', 'title'], ['conf']];
      const tabs = document.querySelectorAll('.nav-item');
      let index;

      try{
      if(this.show_start_date)
      {
       validators=[['description', 'duration', 'startDate', 'startTime', 'title'] ,['conf']];
       if (validators[0].some(item => this.$v.form[item].$invalid)) {

         console.log("item,",item)

         index = 0;
         } else {
         index = 2;
        }
        tabs[index].classList.add('has-error');
        tabs[index].querySelector('.nav-link').click();
      }}catch (e) {
        console.log("highlight Form Errors")
      }


    },
    resetHighlightErrors() {

      const tabs = document.querySelectorAll('.nav-item');
      for (let i = 0; i < tabs.length; ++i) {
        tabs[i].classList.remove('has-error');
      }
    },
    submitForm() {
      this.submitButtonClicked = true;
      this.handleSubmit();
    },
    handleDiffusionTypeChanged() {
      setTimeout(() => {
        const types = ['webinar', 'isPearl', 'screenShare'];
        types.forEach(t => {
          this.form[t] = t === this.form.diffusion;
        });
      }, 100);
    },
    addChapter() {
      if (!this.newChapter) {
        return;
      }
      const chapter = {
        title: this.newChapter,
        chapterOrder: this.form.chapters.length,
        timeCode: null,
      };
      this.form.chapters.push(chapter);
      this.newChapter = '';
      // const chapresEl = this.$refs['ps-chapters'].$el;
      // setTimeout(() => {
      //   chapresEl.scrollTop = chapresEl.scrollHeight;
      // }, 100);
    },
    toggleEditChapter(index, dismiss = true) {
      if (!(this.form.chapters[index] || this.chapterTitle)) {
        return;
      }
      this.form.chapters = this.form.chapters.map((c, i) => {
        if (i === index) {
          if (this.chapterTitle) {
            c.title = this.chapterTitle;
          } else {
            this.chapterTitle = c.title;
          }
          c.isEditMode = !c.isEditMode;
        }
        return c;
      });
      if (dismiss) {
        this.chapterTitle = '';
      }
    },
    removeChapter(index) {
      this.watchUndoRemoveItem(this.form.chapters, index).then(val => {
        this.form.chapters = val;
      });
      this.form.chapters = this.form.chapters.filter((c, i) => i !== index);
    },
    setAddQuestionMode(addQuestionMode) {
      this.addQuestionMode = addQuestionMode;
      this.form.questions = this.form.questions.map(q => {
        q.isEditMode = false;
        return q;
      });
    },
    addQuestion(question) {
      this.form.questions.push(question);
      this.addQuestionMode = false;

      // const questionsEl = this.$refs['ps-questions'].$el;
      // setTimeout(() => {
      //   questionsEl.scrollTop = questionsEl.scrollHeight;
      // }, 100);
    },
    updateQuestion(question, index) {
      this.form.questions = this.form.questions.map((q, i) =>
        i === index ? { ...question, isEditMode: false } : q,
      );
    },
    toggleEditQuestion(index) {
      this.form.questions = this.form.questions.map((q, i) => {
        if (i === index) {
          q.isEditMode = !q.isEditMode;
        }
        return q;
      });
      this.addQuestionMode = false;
    },
    removeQuestion(index) {
      this.watchUndoRemoveItem(this.form.questions, index).then(val => {
        this.form.questions = val;
      });
      this.form.questions = this.form.questions.filter((c, i) => i !== index);
    },
    updateScrollbar() {
      this.$nextTick(() => {
        const ps = this.$refs.ps;
        if (ps) {
          ps.update();
        }
      });
    },
    searchVideo() {
      this.resetPagination('videos');
      this.fetchVideos(this.searchVideoKeyword);
    },
    renderCarousel() {
      this.showCarousel = true;
      this.$nextTick(() => {
        const carousel = this.$refs.carousel;
        if (carousel) {
          carousel.render();
          carousel.goToPage(0);
        }
      });
    },
    selectVideo(slide) {
      this.form.conf.video = slide.id;
      this.form = Object.assign({}, this.form);
      this.form.videoBeforeLive = Object.assign({}, slide, { logo: slide.thumbnail });
      this.toggleBeforeLiveVideoPicker();
    },
    async checkEditMode() {
      const id = this.$route.params.id;
      this.isEditMode = !!id;
      if (this.isEditMode) {
        NProgress.start();
        await this.getLiveById(id);
        NProgress.done();
      }
    },
    getDropzoneOptions(type) {
      const opts = {
        url: '/',
        thumbnailWidth: 150,
        uploadMultiple: true,
        maxFilesize: 5,
        autoProcessQueue: false,
        dictDefaultMessage: '<span class="icon icon-upload"></span>' + i18n.t('upload_files.title'),
      };
      switch (type) {
        case 'media':
          opts.dictDefaultMessage += i18n.t('upload_files.media_type');
          opts.acceptedFiles = 'image/jpg,image/jpeg,image/png,image/gif, video/mp4';
          break;
        case 'file':
          opts.dictDefaultMessage += i18n.t('upload_files.file_type');
          break;
        case 'image':
          opts.dictDefaultMessage += i18n.t('upload_files.image_type');
          opts.acceptedFiles = 'image/jpg,image/jpeg,image/png,image/gif';
          break;
      }
      opts.dictDefaultMessage +=
        '<br>' +
        i18n.t('upload_files.or') +
        '<b><u>' +
        i18n.t('upload_files.click') +
        '</u></b>' +
        i18n.t('upload_files.selected_file');
      return opts;
    },
    replaceSlide(index) {
      this.slideIndex = index;
      window.dz = this.$refs.slidesDZ;
      document.getElementById('slides-dz').click();
    },
    handleDzSlideAdded(files) {
      setTimeout(async () => {
        for (let i = 0; i < files.length; i++) {
          const params = {
            id: 'slides-dz',
            current: i,
            total: files.length,
            type: 'slides',
          };
          const file = files[i];

          const blob = await this.processFile(file);
          await this.uploadThumbnail(blob, params).then(result => {
            const { data } = result;
            const slide = {
              slideType: file.type.indexOf('image') > -1 ? 'Image' : 'Video',
              slide: data.location.path,
              urlSlide: data.location.url,
            };
            if (this.slideIndex > -1) {
              this.form.slides.splice(this.slideIndex, 1, slide);
              this.slideIndex = -1;
            } else {
              this.form.slides.push(slide);
            }
            if (i === files.length - 1) {
              this.removeProgressCircle(params);
            }
          });
        }
        this.$refs.slidesDZ.removeAllFiles();
        // const slidesEl = this.$refs['ps-slides'].$el;
        // setTimeout(() => {
        //   slidesEl.scrollTop = slidesEl.scrollHeight;
        // }, 100);
      }, 100);
    },
    handleDzFileAdded(files) {
      setTimeout(async () => {
        for (let i = 0; i < files.length; i++) {
          const params = {
            id: 'files-dz',
            current: i,
            total: files.length,
            type: 'attatched_files',
          };

          const file = files[i];
          const blob = await this.processFile(file);

          await this.uploadThumbnail(blob, params).then(result => {
            const { data } = result;

            const f = {
              fileName: file.name,
              mimeType: data.location.mimeType,
              title: data.location.path,
            };
            this.form.files = this.form.files.concat(common.buildIcons([f]));
            if (i === files.length - 1) {
              this.removeProgressCircle(params);
            }
          });
        }

        this.$refs.filesDZ.removeAllFiles();
      }, 100);
    },
    handleDzFileCompleted() {
      this.$refs.filesDZ.removeAllFiles();
    },
    handleDzSlideCompleted() {
      this.$refs.slidesDZ.removeAllFiles();
    },
    removeSlide(index) {
      this.watchUndoRemoveItem(this.form.slides, index).then(val => {
        this.form.slides = val;
      });
      this.form.slides = this.form.slides.filter((s, i) => i !== index);
    },
    removeFile(index) {
      this.watchUndoRemoveItem(this.form.files, index).then(val => {
        this.form.files = val;
      });
      this.form.files = this.form.files.filter((f, i) => i !== index);
    },
    handleThumbnailUpdated(thumbnail) {
      this.form.thumbnail = thumbnail;
    },
    handleBeforeLivePosterUpdated(thumbnail) {
      this.form.conf.image = thumbnail;
    },
    handlePageChanged() {
      if (
        this.isEndReached('videos') ||
        this.isLoading('videos') ||
        !(
          this.form.conf.type === 'Video' &&
          this.initInfinitScrollVideos &&
          this.isBeforeLiveVideoPickerVisible
        )
      ) {
        return;
      }
      this.fetchVideos(this.searchVideoKeyword);
    },
    goToListLive() {
      parent.postMessage(
        {
          info: 'goToListLive',
          value: this.getDiffusion,
        },
        '*',
      );
      const cryptext = this.$route.query;
      this.$router.push({ name: 'ListLive', query: cryptext });
    },
    disabledDate(value) {
      const today = new Date();
      let yesterday = new Date();
      yesterday.setDate(today.getDate() - 1);
      return new Date(value) < yesterday;
    },
  },
  created() {
    this.checkEditMode();
    this.fetchContributors();
    this.fetchSurveys();
    this.fetchVideos();
    this.fetchChannels();
    this.fetchLiveTypes();
    this.fetchAllSkinTemplates();
    this.fetchLiveDocuments();
  },
  mounted() {
    // this.$root.$on('setFormLang', lang => {
    //   this.$i18n.locale = lang;
    //   i18n.locale = lang;
    // });


    //todo click outside

    this.$nextTick(() => {
      if (this.$i18n.locale === 'fr') {
        Datepicker.fecha.i18n.monthNamesShort = [
          'Jan',
          'Fev',
          'Mar',
          'Avr',
          'Mai',
          'Juin',
          'Juil',
          'Aout',
          'Sep',
          'Oct',
          'Nov',
          'Dec',
        ];
      }
    });
    const today = new Date();
    let yesterday = new Date();
    yesterday.setDate(today.getDate() - 1);
    this.pastDates = {
      to: yesterday,
    };
    this.getSubscriptionUserList();
    this.getSubscriptionGroupUsersList();
  },
};
</script>

<style lang="scss">
@import '~styles/theme';
@import '@pencilpix/vue2-clock-picker/dist/vue2-clock-picker.min.css';
@import 'vue2-dropzone/dist/vue2Dropzone.min.css';
@import 'vue-multiselect/dist/vue-multiselect.min.css';
@import 'vue2-timepicker/dist/VueTimepicker.css';

%tabs-wrapper {
  .tabs-wrapper {
    position: relative;
    padding: 1em 1.5em 0 1.5em;
    background-color: #fff;
    box-shadow: 0px 3px 1px -2px rgba(0, 0, 0, 0.2), 0px 2px 2px 0px rgba(0, 0, 0, 0.14),
      0px 1px 5px 0px rgba(0, 0, 0, 0.12);
    margin: 0.5em 0;
    .tabs {
      .nav-tabs {
        border-bottom: none !important; ;
        .nav-item {
          position: relative;
          margin: 0 7em 0 0!important;
          &.has-error {
            background-color: rgba(244, 67, 54, 0.05);
            .nav-link {
              padding-right: 2rem;
              border-top-left-radius: 3px;
              border-top-right-radius: 3px;
              a {
                padding: 0.5rem 2rem;
              }
              &.active {
                border-bottom: 3px solid #f44336 !important;
                background-color: transparent;
              }
              &:after {
                position: absolute;
                top: 10px;
                font-size: 0.8em;
                color: #f44336;
                content: '\E904';
                font-family: 'live-icon';
                right: 10px;
              }
            }
          }
          &:not(.has-error) {
            .nav-link {
              &:hover {
                color: inherit;
                border-color: transparent !important;
              }
              &.active {
                border-bottom: 3px solid var(--primary-color, $primary-color) !important;
                background-color: transparent;
              }
            }
          }
          .nav-link {
            color: inherit;
            border: none;
            font-weight: 500;
            display: flex;
            align-items: center;
            justify-content: center;
          }
        }
      }
    }
  }
}
%box-shadow {
  position: relative;
  padding: 1em;
  background-color: #fff;
  box-shadow: 0px 3px 1px -2px rgba(0, 0, 0, 0.2), 0px 2px 2px 0px rgba(0, 0, 0, 0.14),
    0px 1px 5px 0px rgba(0, 0, 0, 0.12);
  margin-bottom: 2em;
}
%form-group {
  .form-group {
    width: 100%;
    .duration-live {
      position: relative;
      &:after {
        font-family: 'live-icon', serif;
        content: '\E910';
        position: absolute;
        left: 0;
        top: 0;
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-align: center;
        -ms-flex-align: center;
        align-items: center;
        padding: 0.375rem 0.75rem;
        margin-bottom: 0;
        font-size: 1rem;
        font-weight: 400;
        line-height: 1.5;
        color: #495057;
        text-align: center;
        white-space: nowrap;
        background-color: #e9ecef;
        border: 1px solid #ced4da;
        border-radius: 0.1em;
      }
      #duration {
        padding-left: 3em;
      }
    }
    &.interactive-options {
      .custom-control-label {
        display: flex !important;
      }
    }
    &.align-infos-live,
    .align-infos-live {
      display: flex;
      flex-direction: row;
      justify-content: flex-start;
      align-items: center;
      .custom-switch {
        padding-left: 3.25rem !important;
      }
      /*.custom-checkbox {*/
      /*width: 30%;*/
      /*}*/
      label {
        /*&.align-infos-live--size {*/
        /*width: 50%;*/
        /*}*/
      }
    }
    .share-live,
    .encoding-key,
    .encoding-url,
    .encoding-name {
      position: relative;
      .input-share,
      .input-encoding-key,
      .input-encoding-url,
      .input-encoding-name {
        padding: 1.5em;
      }
      .copy-button {
        position: absolute;
        top: 0.5em;
        right: 0.55em;
        padding: 0.2em 1em !important;
        border-radius: 2px !important;
      }
    }
    .videos-visibility {
      display: flex;
      flex-direction: column;
    }
    &.is-invalid {
      .form-control {
        &:focus {
          border-color: #dc3545;
        }
      }
    }
    label {
      &.custom-control-label {
        margin-bottom: 0.5rem;
      }
      &.primary,
      &.secondary {
        font-weight: 500;

        display: flex;
        align-items: center;
      }
      &.intervenant-modal {
        font-family: Roboto-Regular;
      }
      &.secondary {
        color: #a9a9a9;
      }
      &.required:after {
        content: ' *';
        font-size: 13px;
        vertical-align: top;
        color: #d50000;
      }
    }
    .form-control {
      box-shadow: none !important;
      &:disabled,
      &[readonly] {
        background-color: #ffffff;
      }
    }
    .primary label,
    .secondary label {
      font-weight: 500;
    }
    div > div.custom-radio .custom-control-input:checked ~ .custom-control-label::before {
      color: #fff;
      background-color: var(--primary-color, $primary-color) !important;
      border-color: var(--primary-color, $primary-color) !important;
    }
    .custom-control-input:checked ~ .custom-control-label::before {
      color: #fff;
      background-color: var(--primary-color, $primary-color) !important;
      border-color: var(--primary-color, $primary-color) !important;
    }
  }
}
.error_message{
  width: 100%;
  margin-top: 0.25rem;
  font-size: 80%;
  color: #dc3545;
}
//.vue-portal-target
.create-live-wrapper{
  padding: 1em 0;
  position: relative;
  @extend %tabs-wrapper;
  .buttons-wrapper {
    position: absolute;
    /*bottom: 0;*/
    right: 0;
    padding: 0.6em 1.5em;
    .btn {
      padding: 0.375rem 2rem;
    }
    .btn-primary {
      color: #fff;
      background-color: var(--primary-color, $primary-color) !important;
      border-color: var(--primary-color, $primary-color) !important;
      box-shadow: inset 0 1px 0 var(--primary-color, $primary-color),
        0 1px 1px var(--primary-color, $primary-color) !important;
    }
  }
  form {
    padding: 0.5em 0;
    &.was-validated {
      .form-group {
        width: 100%;
        &.is-invalid {
          &__custom {
            .mx-input-append,
            .input-group-text,
            .clock-picker__input-container:after {
              color: var(--primary-color, #dc3545);
              border-color: var(--primary-color, #dc3545);
              background-color: #fce1e3;
            }
            .form-control {
              border-color: var(--primary-color, #dc3545);
            }
            .invalid-feedback {
              display: block;
            }
          }
        }
      }
    }
    &.not-ready {
      opacity: 0.4;
      pointer-events: none;
    }
    &:not(.tabs-wrapper) {
      @extend %form-group;
    }
    .tabs-wrapper {
      position: relative;
      padding: 1em 1.5em;
      background-color: #fff;
      box-shadow: 0px 3px 1px -2px rgba(0, 0, 0, 0.2), 0px 2px 2px 0px rgba(0, 0, 0, 0.14),
        0px 1px 5px 0px rgba(0, 0, 0, 0.12);
      height: 100%;
      .tabs {
        .nav-tabs {
          .nav-item {
            position: relative;
            &.has-error {
              background-color: rgba(244, 67, 54, 0.05);
              .nav-link {
                padding-right: 2rem;
                border-top-left-radius: 3px;
                border-top-right-radius: 3px;
                &.active {
                  border-bottom: 3px solid #f44336 !important;
                  background-color: transparent;
                }
                &:after {
                  position: absolute;
                  top: 10px;
                  font-size: 0.8em;
                  color: #f44336;
                  content: '\E904';
                  font-family: 'live-icon';
                  right: 10px;
                }
              }
            }
            &:not(.has-error) {
              .nav-link {
                &:hover {
                  color: inherit;
                  border-color: transparent !important;
                }
                &.active {
                  border-bottom: 3px solid var(--primary-color, $primary-color) !important;
                  background-color: transparent;
                }
              }
            }
            .nav-link {
              color: inherit;
              border: none;
              font-weight: 500;
              display: flex;
              align-items: center;
              justify-content: center;
            }
          }
        }
      }
      @extend %form-group;

      .rm-tabs-wrapper {
        position: relative;
        padding: 1em;
        border: 1px solid #e8e8e8;
        border-radius: 3px;
        margin-bottom: 2em;
        .tab-pane {
          // max-height: 495px;
        }
        .chapters-wrapper {
          .chapter-wrapper {
            display: flex;
            align-items: center;
            justify-content: space-between;
            padding-bottom: 5px;
            margin-bottom: 5px;
            &:not(:last-child) {
              border-bottom: 1px solid #cdd3d9;
            }
            .chapter-container {
              display: flex;
              align-items: center;
              justify-content: start;
              width: 100%;
              .form-group {
                flex-grow: 1;
                position: relative;
              }
              &.question {
                align-items: start;
                justify-content: start;
                flex-grow: 1;
                .question-form-wrapper {
                  flex-grow: 1;
                }
                &.is-open {
                  background-color: #f1f3f4;
                  .sort-handler {
                    padding-top: 0.8em;
                    line-height: 42px;
                  }
                  .index {
                    padding-top: 0.8em;
                    line-height: 38px;
                  }
                }
              }
              .sort-handler {
                padding: 2px 6px;
                border-radius: 2px;
                font-size: 0.8em;
                margin-right: 0.4em;
                cursor: grab;
                color: #9fa7ab;
              }
              .text{
                width: 100%;
              }
              .index {
                font-weight: 600;
              }
            }
            &:hover {
              .rm-actions-wrapper button {
                opacity: 1;
                visibility: visible;
              }
            }
            .rm-actions-wrapper {
              display: flex;
              flex-wrap: nowrap;
              vertical-align: baseline;
              button {
                border-radius: 50%;
                opacity: 0;
                visibility: hidden;
                transition: opacity 0.2s ease, visibility 0.2s ease;
                &:first-child {
                  margin-right: 10px;
                }
              }
            }
          }
        }
        .slides-wrapper {
          margin-right: -30px;
          margin-left: -30px;
          padding: 0 15px;
          .scroll-area {
            margin: 15px 0 0;
          }
          .slide-wrapper {
            position: relative;
            margin-top: 1em;
            &:hover {
              .more-btn-container {
                opacity: 1;
                visibility: visible;
              }
            }
            .img-fluid {
              height: 100%;
              cursor: grab;
            }
            .type-tag {
              position: absolute;
              top: 3px;
              left: 18px;
              background-color: var(--primary-color, $primary-color) !important;
              color: #ffffff;
              padding: 0.1em 0.4em;
              border-radius: 0.125em;
            }
            img,
            video {
              width: 100%;
              vertical-align: top;
              border: none;
              object-fit: cover;
              height: 100%;
              border-radius: 2px;
            }
            .more-btn-container {
              position: absolute;
              right: 8px;
              top: 0;
              opacity: 0;
              visibility: hidden;
              transition: opacity 0.2s ease, visibility 0.2s ease;
              button {
                color: #ffffff;
                text-shadow: 1px 1px 3px rgba(0, 0, 0, 0.8);
                padding-top: 0.5em;
              }
              .dropdown-menu {
                transform: translate3d(-90px, 30px, 0px) !important;
                padding: 2px 0;
                min-width: 120px;
                .dropdown-item {
                  padding: 2px 8px;
                  &:active,
                  .active,
                  &:hover {
                    color: #fff;
                    background-color: var(--primary-color, $primary-color) !important;
                    border-color: var(--primary-color, $primary-color) !important;
                  }
                }
              }
            }
          }
        }
      }
      .sub-form-control {
        padding-left: 1.5em;
        padding-top: 0.5em;
      }
      .video-picker-wrapper {
        position: relative;
        padding: 1em;
        border: 1px solid #e8e8e8;
        border-radius: 3px;
        .video-slides-wrapper {
          figure {
            cursor: pointer;
            position: relative;
            border-radius: 3px;
            overflow: hidden;
            margin-bottom: 0.2em;
            &:hover {
              .video-overlay {
                opacity: 1;
                visibility: visible;
              }
            }
            .video-overlay {
              position: absolute;
              height: 100%;
              width: 100%;
              left: 0;
              top: 0;
              bottom: 0;
              right: 0;
              background: var(--primary-color, $primary-color) !important;
              opacity: 0;
              visibility: hidden;
              transition: all 0.2s ease;
              display: flex;
              align-items: center;
              justify-content: center;
              &.in {
                opacity: 1;
                visibility: visible;
              }
              .btn {
                border-radius: 0.2em;
                &.btn-outline-light:hover {
                  color: var(--primary-color, $primary-color) !important;
                }
                &.btn-light {
                  color: var(--primary-color, $primary-color) !important;
                  &:hover {
                    background-color: #ffffff;
                    border-color: #ffffff;
                  }
                }
              }
            }
            .img {
              width: 100%;
            }
          }
          .video-name {
            margin: 0 10px 0 0;
            font-size: 0.8em;
            word-wrap: break-word;
            line-height: 1.2em;
            height: 2.4em;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
            overflow: hidden;
            text-overflow: ellipsis;
            &.selected {
              color: var(--primary-color, $primary-color) !important;
            }
          }
        }
      }
      .start-date-picker {
        .vdp-datepicker {
          &__calendar {
            border-radius: 3px;
            margin-top: 1px;
            margin-bottom: 1px;
            bottom: 100%;
            header {
              span {
                border-radius: 3px;
                &.prev,
                &.next {
                  text-indent: initial;
                  color: transparent;
                  &:after {
                    color: #444444;
                    font-size: 0.8em;
                    font-family: 'live-icon', serif;
                    border: none;
                    margin: 0;
                  }
                }
                &.prev:after {
                  content: '\e908';
                }
                &.next:after {
                  content: '\e90a';
                }
              }
            }
            .cell {
              border-radius: 2px;
              &.selected,
              &.actived {
                background: var(--primary-color, $primary-color) !important;
                color: #ffffff;
              }
              &:not(.blank):not(.disabled) {
                &.day,
                &.month,
                &.year {
                  &:hover {
                    border-color: var(--primary-color, $primary-color) !important;
                  }
                }
              }
            }
          }
        }
      }

      .clock-picker {
        &__input-container {
          position: relative;
          &:after {
            font-family: 'live-icon', serif;
            content: '\e907';
            position: absolute;
            left: 0;
            top: 0;
            display: flex;
            align-items: center;
            padding: 0.375rem 0.75rem;
            margin-bottom: 0;
            font-size: 1rem;
            font-weight: 400;
            line-height: 1.5;
            color: #495057;
            text-align: center;
            white-space: nowrap;
            background-color: #e9ecef;
            border: 1px solid #ced4da;
            border-radius: 0.1em;
          }

          input.form-control {
            padding-left: 3em;
            &.before-hour-rule {
              padding-left: 2.5em !important;
            }
          }
        }
        &__dialog-header {
          padding: 1rem 1.5rem;
        }
        &__dialog-content {
          text-align: center;
        }
        &__dialog-actions {
          padding: 0;
        }
        &__dialog-action {
          padding: 0.5rem 1rem;
          &:nth-child(2):not(:disabled) {
            background-color: var(--primary-color, $primary-color) !important;
            color: #ffffff !important;
          }
        }
      }
      .beforeHour {
        .clock-picker {
          &__input-container {
            &:after {
              font-family: 'live-icon', serif;
              content: '\e907';
              position: absolute;
              left: 0;
              top: 0;
              display: flex;
              align-items: center;
              padding: 0.475rem 0.75rem !important;
              margin-bottom: 0;
              font-size: 0.9rem;
              font-weight: 400;
              line-height: 1.5;
              color: #495057;
              text-align: center;
              white-space: nowrap;
              background-color: transparent !important;
              border: none !important;
              border-radius: 0.1em;
            }
          }
        }
      }
      .vue-input-tag-wrapper {
        border-color: #ced4da;
        border-radius: 0.1em;
        .input-tag {
          background-color: var(--primary-color, $primary-color) !important;
          border-color: var(--primary-color, $primary-color) !important;
          border-radius: 15px;
          padding: 4px 4px 3px 15px;
          color: #fff;
          .remove {
            color: #f1f3f4;
            &:hover {
              &:before {
                background: var(--primary-color, $primary-color) !important;
              }
            }
            &:before {
              content: '\D7';
              font-size: 1.2em;
              line-height: 16px;
              vertical-align: middle;
              margin-left: 8px;
              padding: 3px;
              width: 22px;
              display: inline-block;
              text-align: center;
              border-radius: 50%;
              transition: all 0.2s ease;
            }
          }
        }
      }
      .multiselect {
        &__tag,
        &__option--highlight,
        &__option--highlight:after {
          background: var(--primary-color, $primary-color) !important;
        }
        &__tag {
          background-color: var(--primary-color, $primary-color) !important;
          border-color: var(--primary-color, $primary-color) !important;
          border-radius: 15px;
          padding: 8px 30px 8px 15px;
          color: #fff;
          margin-bottom: 0;
        }
        &__tag-icon {
          right: 4px;
          top: 4px;
          bottom: 4px;
          width: 22px;
          line-height: 22px;
          border-radius: 50%;
          background-color: rgba(255, 255, 255, 0.4);
          &:focus,
          &:after {
            color: var(--primary-color, $primary-color) !important;
          }
        }
      }
      .vue-dropzone {
        border-style: dashed;
        border-radius: 0.4em;
        background-color: #f7f7f7;
        position: relative;
        .dz-message {
          font-size: 0.8em;
          display: block !important;
          .icon {
            display: block;
            font-size: 4em;
            color: #b6c0c3;
          }
        }
        .dz-preview {
          display: none;
        }
      }
      .attached-files-wrapper {
        display: flex;
        flex-wrap: wrap;
        margin: -15px -0.5em 10px;
        .attached-file {
          position: relative;
          flex: 0 0 0;
          padding: 0.2em;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          margin: 0.5em;
          background-color: #f1f1f1;
          min-width: 100px;
          overflow: hidden;
          &:hover {
            .attached-file__btn-remove {
              opacity: 1;
              visibility: visible;
            }
          }
          &__icon {
            font-size: 3em;
            color: #859cab;
          }
          &__name {
            font-size: 0.8em;
            margin-bottom: 5px;
            line-height: 1.2em;
            height: 2.4em;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 2;
            font-weight: 600;
            text-align: center;
            width: 100%;
          }
          &__btn-remove {
            position: absolute;
            right: 0;
            top: 0;
            padding: 0.2em;
            border: none;
            color: $danger;
            opacity: 0;
            visibility: hidden;
            transition: opacity 0.2s ease, visibility 0.2s ease;
            &:hover {
              color: darken($danger, 10%);
            }
          }
        }
      }
      .btn-remove {
        color: $danger;
        &:hover {
          color: darken($danger, 10%);
        }
      }
    }
  }
  .scroll-area {
    max-height: 300px;
    min-height: 180px;
    padding: 0 15px;
    margin: 0 -15px;
    &.scroll-chapters {
      max-height: 440px;
    }
    &.scroll-questions {
      max-height: 450px;
    }
  }
  .inline-submit-btn {
    position: absolute;
    top: 0;
    right: 0;
    margin: 3px;
  }
  .add-item-wrapper {
    padding: 1em 1em 0;
    margin: 0 -1em;
    border-top: 1px solid #e8e8e8;
    button.btn.btn-link {
      box-shadow: none !important;
      text-decoration: none;
      color: var(--primary-color, $primary-color) !important;
    }
  }
  .before-live-video-container {
    figure {
      max-width: 100%;
      width: 360px;
      border-radius: 3px;
      overflow: hidden;
      position: relative;
      margin-bottom: 0.2em;
      .img {
        width: 100%;
      }
    }
    &__btn {
      position: absolute;
      top: 0;
      right: 0;
      background: rgba(0, 0, 0, 0.6);
      margin: 0.5em;
      color: #ffffff;
      border: 1px solid rgba(0, 0, 0, 0.5);
    }
    &__overlay {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      color: #ffffff;
      font-size: 3em;
      background-color: rgba(0, 0, 0, 0.2);
    }
  }
  .was-validated .form-control:invalid ~ .video-picker-wrapper {
    border-color: #dc3545;
  }
}
.filter-date {
  .custom-control-label {
    padding-left: 5px;
  }
  .mx-datepicker {
    width: 100%;
    .mx-datepicker-popup {
      .mx-calendar.mx-calendar-panel-date {
        .mx-calendar-content {
          .cell.actived:not(.today) {
            color: #fff !important;
            background-color: var(--primary-color, $primary-color) !important;
            border-color: var(--primary-color, $primary-color) !important;
            box-shadow: inset 0 1px 0 var(--primary-color, $primary-color),
              0 1px 1px var(--primary-color, $primary-color) !important;
          }
          .mx-panel-date td.today {
            color: var(--primary-color, $primary-color) !important;
            background-color: #fff !important;
            border-color: #fff !important;
            &.actived {
              color: #fff !important;
              background-color: var(--primary-color, $primary-color) !important;
              border-color: var(--primary-color, $primary-color) !important;
              box-shadow: inset 0 1px 0 var(--primary-color, $primary-color),
                0 1px 1px var(--primary-color, $primary-color) !important;
            }
          }
        }
      }
    }
  }
  .mx-datepicker.input-text {
    padding: 0 !important;
    border: 1px solid #dee2e6 !important;
    box-shadow: none;
    width: 100%;
  }
  input.mx-input {
    box-shadow: none;
    padding: 0 10px;
  }
  i.mx-input-icon.mx-clear-icon {
    font-size: 14px;
  }
}
.vdp-datepicker {
  &.input-text {
    input[type='text'] {
      font-size: 14px;
    }
  }
  .vdp-datepicker__clear-button {
    position: absolute;
    top: 10px;
    right: 0;
  }
}
.vdp-datepicker__calendar {
  font-size: 14px;
  .input-text {
    input[type='text'] {
      font-size: 14px;
    }
  }
}
.selectedDate {
  padding: 0 3.1em;
}
.mx-input-append {
  left: 0;
  background-color: #e9ecef;
  width: 42px;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  padding: 0.375rem 0.75rem;
  margin-bottom: 0;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  //color: #495057;
  text-align: center;
  white-space: nowrap;
  border: 1px solid #ced4da;
  border-radius: 0.1em;
}
// new css
::v-deep .filter-date .mx-panel-date td.today {
  color: var(--primary-color, $primary-color) !important;
}

.screen-share-select option {
  &:hover,
  &:indeterminate {
    color: #fff;
    background-color: var(--primary-color, $primary-color) !important;
    border-color: var(--primary-color, $primary-color) !important;
  }
}
.btn-primary {
  color: #fff;
  background-color: var(--primary-color, $primary-color) !important;
  border-color: var(--primary-color, $primary-color) !important;
  box-shadow: inset 0 1px 0 var(--primary-color, $primary-color),
    0 1px 1px var(--primary-color, $primary-color) !important;
}
.conf-label[disabled='disabled'] {
  color: #6c757d;
}
.vignette-infos {
  display: flex;
  flex-direction: row;
}
.position-icon {
  margin: 0 0.5em;
  height: 1.5em;
  &.icon-infos:before {
    color: #dbd8d8;
    background: #a7a4a4;
    font-size: 1.3em;
    border-radius: 100%;
  }
}
.tm {
  font-size: 0.7em;
  padding: 0 0.5em;
}
.configuration-tab {
  .container-default {
    width: 100%;
    height: 100%;
    justify-content: center;
    align-items: center;
    vertical-align: center;
    background-color: #f8f8f8;

    &__themes {
      height: 100vh;
      display: flex;
      flex-direction: column;
      &:hover,
      &:active {
        color: #797a8e;
      }

      &__container {
        display: flex;
        flex-direction: column;
        height: 70%;
        /*border-bottom: 1px solid #d9d8e0;*/

        &__list {
          display: flex;
          flex-direction: row;
          font-size: 2em;
          align-items: center;
          color: #797a8e;
          padding: 2em 1.5em;
          &:hover,
          &:active {
            color: #797a8e;
          }
        }
        &__cards {
          display: flex;
          flex-direction: row;
          /*justify-content: center;*/
          color: #797a8e;
          .template {
            position: relative;
            width: 17.7em;
            height: 10em;
            .template-card {
              cursor: pointer;
              &.selected {
                border: 2px solid var(--primary-color) !important;
              }
            }
            .template-title {
              display: flex;
              justify-content: center;
              &.selected {
                color: var(--primary-color) !important;
              }
            }
            .show-more {
              background: #e9e9e9;
              height: 80%;
              width: 100%;
            }
          }
        }
      }
    }
  }

  ::v-deep article {
    box-shadow: 0px 3px 3px -2px rgba(0, 0, 0, 0.2), 0px 3px 4px 0px rgba(0, 0, 0, 0.14),
      0px 1px 8px 0px rgba(0, 0, 0, 0.12) !important;

    img {
      height: 100%;
    }
    .card-body {
      flex: 1 1 auto;
      padding: 1.25rem;
      position: absolute;
      width: 100%;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;

      .card-text,
      .card-title {
        display: none;
        position: absolute;
        bottom: 0;
        background-color: #e6e7e9f0;
        color: #1279be;
        font-family: sans-serif;
        cursor: pointer;
        width: 100%;
        padding: 1em 0;
        margin: 0;
        &.show-more-templates {
          display: flex !important;
          color: #797a8e !important ;
          flex-direction: column;
          .position-text {
            display: flex;
            justify-content: center;
            .title-show-more {
              font-weight: bold;
            }
          }
        }
      }
      &:hover {
        .card-text {
          display: block;
        }
      }

      .btn-preview {
        z-index: 4;
        background-color: transparent;
        color: white;
        position: absolute;
        border-radius: 20px;
        border-color: #f2fafd;
        -webkit-box-align: center;
        -ms-flex-align: center;
        align-items: center;
        -webkit-box-pack: center;
        -ms-flex-pack: center;
        justify-content: center;
        vertical-align: middle;
        padding: 0.5em 2em;
        font-weight: bold;
        border: 2px solid #f2fafd;
        a {
          color: white !important;
          text-decoration: none;
          &:active,
          &:focus {
            color: white !important;
            text-decoration: none;
          }
        }
      }

      .card-theme-type {
        display: block;
        top: 0;
        position: absolute;
        bottom: 80%;
        background-color: #9d0505;
        /* padding: 0 10px; */
        color: white;
      }
    }
  }
}
.intervenants {
  display: flex;
  flex-direction: row;
  width: 100%;
  align-items: center;
  .intervenants-text {
    display: flex;
    justify-content: flex-start;
    width: 100%;
  }
  .intervenants-icons {
    display: flex;
    justify-content: center;
    align-items: center;
    .icon-edit,
    .icon-trash {
      cursor: pointer;
      padding: 0 0.5em;
      color: #797a8e;
    }
  }
}
.add-intervenants-button,
.add-rule-button {
  //color: var(--primary-color);
  color: #6c757d;
  display: flex;
  justify-content: flex-end;
 // cursor: pointer;
  align-items: center;
  &--position {
    justify-content: flex-start;
  }
  a {
    display: flex;
    justify-content: center;
    align-items: center;
    .button-add {
      font-weight: 700;
      font-size: 1.5em;
      padding: 0 0.5em;
    }
    .add-rule {
      text-decoration: underline;
    }
  }
}
.bg-header-secondary {
  background-color: #e9ecef !important;
}
.btn-header-secondary {
  background-color: #b7b7b7 !important;
  &.btn {
    color: white !important;
  }
}
.footer-intervenant {
  border-top: none !important;
  button {
    padding: 0.4em 2em !important;
    border-radius: 3px !important;
    font-size: 0.9em !important;
  }
}

.ck.ck-editor__editable_inline {
  border: 1px solid #e9ecef !important;
}
.positions-text {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0.2em;
}
.infos-align {
  display: flex;
  flex-direction: row;
  align-items: center;
  /*width: 100%;*/
  &.infos-vignette-align {
    position: absolute;
    top: 2em;
  }
  .text-infos {
    display: none;
    padding: 0 !important;
    /*margin: 0 !important;*/
  }
  &:hover {
    .text-infos {
      display: block !important;
      span {
        padding: 0.5em 1em;
        display: flex;
        font-size: 0.9em;
      }
    }
  }
}
.header-intervenant {
  font-family: Roboto-Medium;
}
.tooltip {
  .tooltip-inner {
    @extend %box-shadow;
    color: #777777;
    display: flex;
    width: 100%;
    max-width: 100%;
    justify-content: center;
    align-items: center;
    flex-wrap: wrap;
  }
  .arrow:before {
    border-right-color: white !important;
    border-left-color: white !important;
    border-bottom-color: white !important;
    border-top-color: white !important;
  }
}
.action-start-direct{
  display: flex;
  justify-content: center;
  margin-top: 1em;
  margin-bottom: 1em;
}
.action-choix{
  display: flex;
  justify-content: center;
  margin-bottom: -1em;
}


#modal-start-direct-v2 {


  .custom-control-input {
    position: absolute;
    z-index: -1; // Put the input behind the label so it doesn't overlay text
    opacity: 0;

    &:checked ~ .custom-control-label::before {
      color: var(--primary-color)!important;
      border-color:var(--primary-color)!important;
      background-color:  var(--primary-color)!important;

    }
  }


  .custom-control-input:checked .custom-control-label::before {
    color: #fff;
    border-color: var(--primary-color)!important;
    background-color:  var(--primary-color)!important;
  }

  .modal-dialog {
    justify-content: center;
    display: flex;
  }
  .modal-content{
    width: 85% !important;
  }
  @media screen and (max-width: 990px){
    .action-choix , .desc{
      font-size: 14px!important;
    }
    .modal-content{
      width: 100% !important;
    }
    .subTitle{
      font-size: 20px;
    }
  }
}
.subTitle {
  display: flex;
  justify-content: center;
  font-size: 22px;
  margin-bottom: 0.5em;
}
.bg-custom-secondary {
  background-color: #f2f2f2 !important;
}

.no-p-r{
  padding-right: 0!important;
}
.generer-pwd{
  font-size: 14px;
  font-weight: 300!important;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #6e6e6e;
}

.ListMail{
  position: absolute;
  box-shadow: 0px 3px 1px -2px rgba(0,0,0,0.2), 0px 2px 2px 0px rgba(0,0,0,0.14), 0px 1px 5px 0px rgba(0,0,0,0.12);
  z-index: 9999;
  background-color: white;
  width: 263px;
  .header{
    height: 30px;
    width: 263px;
    background-color: #f6f6f6;
    height: 46px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
  }

  .context{
    padding: 0.2em 0.5em;
    display: flex;
    justify-content: space-between;
    width: 100%;
    padding: 0 1em;
    align-items: center;
  }

  .fermer{
    font-size: 16px;
    font-weight: 500;
    color: #2c3e50;
    cursor: pointer;
    font-size: 12px;
    font-weight: 900;
    font-family: Roboto!important;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    background-color: transparent;
    border: none!important;
  }
  .add-mail-form{
    width: 100%;
    display: flex;
    flex-direction: row;
    position: relative;
    align-items: center;
  }
  .addmail{
    padding: 1em;
    display: flex;
  }
  .cursor{
    cursor: pointer;
  }
  .icon-add{
    cursor: pointer;
    position: absolute;
    font-size: 26px;
    font-weight: 900;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    color: #6ba52f;
    background-color: transparent;
    border: none!important;;
    right: 0;
    height: 24px;
    font-size: 18px;
    font-family: Roboto!important;
  }
  .list-mail-to-add{
    //max-height: 150px;
    //overflow-y: auto;
    padding:0 1em 1em 1em;
    .onemail{
      padding: 0.2em 0em;
      display: flex;
      justify-content: space-between;
      .icon-trash{
        color: #a2a2a2;
      }
    }
  }

}
.action-btn-modal{
  display: flex;
  justify-content: flex-end;
}

.action-BTN{
  position: absolute;
  top: 0.5em;
  right: 1em;
}
  .DifuserBtn{
    background-color:#EF1313!important;
    border:1px solid #9A0303!important;
    border-radius: 5px;
    width: 8em;
    color:#ffffff!important;
  }
  .SaveBTN{
    background-color:var(--primary-color)!important;
    border:1px solid var(--primary-color)!important;
    border-radius: 5px;
    width: 8em;
    color:#ffffff!important;

  }

  .Annuler{
    background-color: #CBCBCB !important;
    border-radius: 5px;
    border-color: #CBCBCB !important;
    width: 8em;
    color:#ffffff!important;

  }

  .action-BTN-mobile{
    display: flex;
    justify-content: flex-end;
  }

  .documents-share-panel {
    padding: 16px;
    border: 1px solid #d9e4f2;
    border-radius: 12px;
    background: #f8fbff;
  }
  .documents-share-panel__header,
  .documents-share-panel__actions,
  .documents-share-item,
  .documents-share-item__controls {
    display: flex;
    gap: 12px;
  }
  .documents-share-panel__header,
  .documents-share-item {
    justify-content: space-between;
    align-items: center;
  }
  .documents-share-panel__actions {
    flex-wrap: wrap;
  }
  .documents-share-panel__hint,
  .documents-share-panel__state {
    margin: 12px 0 0;
    font-size: 13px;
    color: #5b6b7f;
  }
  .documents-share-list {
    margin-top: 12px;
    display: flex;
    flex-direction: column;
    gap: 10px;
    max-height: 360px;
    overflow-y: auto;
    padding-right: 6px;
  }
  .documents-share-item {
    padding: 12px;
    border-radius: 10px;
    background: #fff;
    border: 1px solid #e4ebf5;
  }
  .documents-share-item__main {
    min-width: 0;
  }
  .documents-share-item__name {
    font-weight: 600;
    color: #16324f;
    word-break: break-word;
  }
  .documents-share-item__meta {
    margin-top: 6px;
  }
  .documents-share-item__badge {
    display: inline-flex;
    align-items: center;
    padding: 3px 8px;
    border-radius: 999px;
    font-size: 11px;
    font-weight: 600;
    background: #eef2f7;
    color: #5b6b7f;
  }
  .documents-share-item__badge.is-public {
    background: #e5f7ea;
    color: #1d7a38;
  }
  .documents-share-item__badge.is-pending {
    background: #fff3cd;
    color: #8a6d1f;
  }
  .documents-share-item__controls {
    flex-wrap: wrap;
    justify-content: flex-end;
    align-items: center;
  }

  @media screen and (max-width:765px ){
    .action-BTN{
      display: none;
    }
    %tabs-wrapper {
      .tabs-wrapper {
        .tabs {
          .nav-tabs {
            .nav-item {
              margin: 0 2em 0 0!important;}}}}}
    .documents-share-panel__header,
    .documents-share-item,
    .documents-share-item__controls {
      flex-direction: column;
      align-items: stretch;
    }

  }
@media screen and (min-width:765px ){
    .action-BTN-mobile{
      display: none;
    }
  }
.ck-file-dialog-button{
  display: none!important;
}

.vue__time-picker .dropdown ul li:not([disabled]).active, .vue__time-picker .dropdown ul li:not([disabled]).active:focus, .vue__time-picker .dropdown ul li:not([disabled]).active:hover {
  background:var(--primary-color, $primary-color) !important;
}

.vue__time-picker input.display-time {
  height: 2.4em!important;
}
.vue__time-picker .dropdown{
  top: calc(2.4em - 200px);
}
</style>



// WEBPACK FOOTER //
// src/components/LiveFormV2.vue